<template>

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   version="1.1"
   x="0px"
   y="0px"
   width="138.60001"
   height="1134.4"
   viewBox="0 0 138.60001 1134.4"
   xml:space="preserve"
   id="svg721"
   sodipodi:docname="pantalla 7-11 mobile.svg"
   inkscape:version="0.92.4 (5da689c313, 2019-01-14)"><metadata
   id="metadata727"><rdf:RDF><cc:Work
       rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
         rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title></dc:title></cc:Work></rdf:RDF></metadata><defs
   id="defs725" /><sodipodi:namedview
   pagecolor="#ffffff"
   bordercolor="#666666"
   borderopacity="1"
   objecttolerance="10"
   gridtolerance="10"
   guidetolerance="10"
   inkscape:pageopacity="0"
   inkscape:pageshadow="2"
   inkscape:window-width="1920"
   inkscape:window-height="1017"
   id="namedview723"
   showgrid="false"
   inkscape:zoom="0.80995281"
   inkscape:cx="319.70807"
   inkscape:cy="927.62856"
   inkscape:window-x="-8"
   inkscape:window-y="-8"
   inkscape:window-maximized="1"
   inkscape:current-layer="pantalla_7" />
<g
   id="Capa_2"
   transform="translate(-114.1,-17.300003)">
</g>
<g
   id="pantalla_1"
   transform="translate(-114.1,-17.300003)">
</g>
<g
   id="pantalla_2"
   transform="translate(-114.1,-17.300003)">
</g>
<g
   id="pantalla__3"
   transform="translate(-114.1,-17.300003)">
</g>
<g
   id="pantalla_4"
   transform="translate(-114.1,-17.300003)">
</g>
<g
   id="pantalla_5"
   transform="translate(-114.1,-17.300003)">
</g>
<g
   id="pantalla_7"
   transform="translate(-114.1,-17.300003)">
	<linearGradient
   id="SVGID_1_"
   gradientUnits="userSpaceOnUse"
   x1="180.88091"
   y1="591.34082"
   x2="185.88091"
   y2="591.34082">
		<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop10" />
		<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop12" />
	</linearGradient>
	
		<line
   style="fill:none;stroke:url(#SVGID_1_);stroke-width:5;stroke-miterlimit:10"
   x1="183.39999"
   y1="79.400002"
   x2="183.39999"
   y2="1103.3"
   id="line15" />
	<g
   id="img1"
   :class="[{'': vistos[0]} ]" @click="darVisto(0)"
   inkscape:label="#XMLID_8154_">
		<linearGradient
   id="XMLID_424_"
   gradientUnits="userSpaceOnUse"
   x1="124.3574"
   y1="75.942902"
   x2="241.5215"
   y2="75.942902">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop17" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop19" />
		</linearGradient>
		
			<circle
   id="XMLID_8303_"
   style="fill:#ffffff;stroke:url(#XMLID_424_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="75.900002"
   r="57.099998" />
		<g
   id="XMLID_8159_">
			<defs
   id="defs24">
				<circle
   id="XMLID_8160_"
   cx="182.89999"
   cy="75.900002"
   r="57.200001" />
			</defs>
			<clipPath
   id="XMLID_426_">
				<use
   xlink:href="#XMLID_8160_"
   style="overflow:visible"
   id="use26"
   x="0"
   y="0"
   width="100%"
   height="100%" />
			</clipPath>
			<g
   id="XMLID_8161_"
   clip-path="url(#XMLID_426_)">
				
					<linearGradient
   id="XMLID_427_"
   gradientUnits="userSpaceOnUse"
   x1="165.06641"
   y1="-15848.729"
   x2="165.06641"
   y2="-15978.187"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop29" />
					<stop
   offset="1"
   style="stop-color:#707070"
   id="stop31" />
				</linearGradient>
				<path
   id="XMLID_8302_"
   class="st1026"
   d="M 168.3,143.7 158,140.2 c 0,0 -4.3,-4.4 -0.7,-14.7 0,0 1.8,-6.1 1.5,-11.5 0,0 2.7,-2.1 0.1,-5.6 0,0 1.2,-11.2 -5.4,-21.7 0,0 -3.7,-10.4 0.8,-42.1 0,0 0.2,-5.9 7.5,-7.7 0,0 14.2,-5.3 16.5,-1.4 -0.1,-0.1 -1.1,103.9 -10,108.2 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_427_)" />
				
					<linearGradient
   id="XMLID_429_"
   gradientUnits="userSpaceOnUse"
   x1="162.66499"
   y1="-15909.519"
   x2="213.08501"
   y2="-15909.519"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop35" />
					<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop37" />
				</linearGradient>
				<path
   id="XMLID_8301_"
   style="fill:url(#XMLID_429_)"
   d="m 166.6,47.8 -3.7,32.5 c 0,0 -1.5,9.1 3.7,14.2 0,0 7.1,11.4 0.9,35.7 0,0 -4.5,15.1 3.6,13.9 l 36.3,-6.9 c 0,0 6.5,-1.4 1.4,-14.2 0,0 -4.6,-21.2 3,-38.6 0,0 3.4,-1.2 -0.9,-39.9 z"
   inkscape:connector-curvature="0" />
				
					<linearGradient
   id="XMLID_430_"
   gradientUnits="userSpaceOnUse"
   x1="189.334"
   y1="-15855.2"
   x2="189.334"
   y2="-15958.433"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop41" />
					<stop
   offset="1"
   style="stop-color:#707070"
   id="stop43" />
				</linearGradient>
				<path
   id="XMLID_8300_"
   class="st1027"
   d="m 171.5,46.1 -2.3,35 c 0,0 -1.2,5.8 1.1,10.4 0,0 5.4,25.5 1.1,40 0,0 -3,10.9 0.7,10.3 l 33.7,-6.8 c 0,0 3.2,-1.9 0,-9 0,0 -4,-25.4 1.4,-38.3 0,0 3.2,-3.8 2.2,-12.5 l -2.3,-31.7 c 0.2,0.1 -22.2,-4.7 -35.6,2.6 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_430_)" />
				
					<linearGradient
   id="XMLID_432_"
   gradientUnits="userSpaceOnUse"
   x1="163.166"
   y1="-15953.963"
   x2="163.166"
   y2="-15854.965"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop47" />
					<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop49" />
				</linearGradient>
				<path
   id="XMLID_8299_"
   class="st1028"
   d="m 159.5,140.7 c 0,0 -3.2,-5.2 0,-14.8 0,0 5.5,-19.8 -4,-39 0,0 -1.1,-18 2.8,-42.4 0,0 -0.5,-4.9 13.5,-7.7 l -0.3,-0.5 c 0,0 -13.7,2.2 -14.1,8.1 0,0 -3.1,17.9 -2.9,42.2 l 0.6,1.5 c 0,0 9.8,18.4 2.7,40.3 0,0 -2.3,7 0.8,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_432_)" />
				
					<linearGradient
   id="XMLID_450_"
   gradientUnits="userSpaceOnUse"
   x1="191.45509"
   y1="-15856.278"
   x2="191.45509"
   y2="-15956.135"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop53" />
					<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop55" />
				</linearGradient>
				<path
   id="XMLID_8298_"
   class="st1029"
   d="m 173.7,46.1 -2.3,35 c 0,0 -1.2,5.8 1.1,10.4 0,0 5.4,25.5 1.1,40 0,0 -3.1,10.4 0.6,9.9 l 33.7,-6.3 c 0,0 3.2,-1.9 0,-9 0,0 -4,-25.4 1.4,-38.3 0,0 3.2,-3.8 2.2,-12.5 l -2.3,-31.7 c 0.2,0 -22.1,-4.8 -35.5,2.5 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_450_)" />
				
					<linearGradient
   id="XMLID_455_"
   gradientUnits="userSpaceOnUse"
   x1="201.60741"
   y1="-15856.095"
   x2="210.9238"
   y2="-15856.095"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#B2B8D1"
   id="stop59" />
					<stop
   offset="1"
   style="stop-color:#545D70"
   id="stop61" />
				</linearGradient>
				<path
   id="XMLID_8297_"
   style="fill:url(#XMLID_455_);stroke:#383838;stroke-miterlimit:10"
   d="m 201.6,36.8 c 0,0 8,0.6 8.8,4.2 l 0.5,3.5 -7.2,0.5 z"
   inkscape:connector-curvature="0" />
				
					<linearGradient
   id="XMLID_7789_"
   gradientUnits="userSpaceOnUse"
   x1="190.91409"
   y1="-15950.601"
   x2="190.91409"
   y2="-15928.402"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop65" />
					<stop
   offset="1"
   style="stop-color:#272A2A"
   id="stop67" />
				</linearGradient>
				<path
   id="XMLID_8296_"
   style="fill:url(#XMLID_7789_);stroke:#232323;stroke-miterlimit:10"
   d="m 203.2,132.2 -24.5,4.4 c -1,0.2 -1.8,-0.5 -1.8,-1.5 v -18.2 c 0,-1 0.8,-2 1.8,-2.2 l 24.5,-4.4 c 1,-0.2 1.8,0.5 1.8,1.5 V 130 c 0,1.1 -0.8,2 -1.8,2.2 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_8295_"
   class="st687"
   d="m 203.2,107.3 -24.5,3.7 c -1,0.2 -1.8,-0.5 -1.8,-1.5 V 91.3 c 0,-1 0.8,-2 1.8,-2.2 l 24.5,-3.7 c 1,-0.2 1.8,0.5 1.8,1.5 v 18.2 c 0,1.1 -0.8,2 -1.8,2.2 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
				<path
   id="XMLID_8294_"
   class="st687"
   d="m 203.2,84 -24.5,3.7 c -1,0.2 -1.8,-0.5 -1.8,-1.5 v -6.8 c 0,-1 0.8,-2 1.8,-2.2 l 24.5,-3.7 c 1,-0.2 1.8,0.5 1.8,1.5 v 6.8 c 0,1 -0.8,2 -1.8,2.2 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
				<path
   id="XMLID_8292_"
   class="st1047"
   d="m 201.9,106.2 -23.3,3.5 c -1,0.2 -1.8,-0.5 -1.8,-1.4 V 91.6 c 0,-1 0.8,-1.9 1.8,-2.1 L 201.9,86 c 1,-0.2 1.8,0.5 1.8,1.4 V 104 c 0,1.1 -0.8,2 -1.8,2.2 z"
   inkscape:connector-curvature="0"
   style="fill:#a2a599" />
				<path
   id="XMLID_8291_"
   class="st1047"
   d="m 201.9,83.1 -23.3,3.5 c -1,0.2 -1.8,-0.5 -1.8,-1.4 v -5.8 c 0,-1 0.8,-1.9 1.8,-2.1 l 23.3,-3.5 c 1,-0.2 1.8,0.5 1.8,1.4 V 81 c 0,1 -0.8,1.9 -1.8,2.1 z"
   inkscape:connector-curvature="0"
   style="fill:#a2a599" />
				<path
   id="XMLID_8290_"
   class="st839"
   d="m 159.5,126 8.3,3 c 0,0 1.4,-1.8 1,-4.5 l -8.3,-3.3 c -0.1,0 0,3.1 -1,4.8 z"
   inkscape:connector-curvature="0"
   style="fill:#68696d" />
				<path
   id="XMLID_8289_"
   class="st107"
   d="m 168.8,119.5 -0.8,4.7 -7.6,-3 c 0,0 -0.2,-2.8 0.5,-4.7 z"
   inkscape:connector-curvature="0"
   style="fill:#505154" />
				<polygon
   id="XMLID_8288_"
   class="st979"
   points="159.5,126 159.2,127 166.8,129.5 167.8,129 "
   style="fill:#353638" />
				<polygon
   id="XMLID_8287_"
   class="st979"
   points="169.7,118.2 168.8,119.5 160.9,116.5 161.5,115.3 "
   style="fill:#353638" />
				<polygon
   id="XMLID_8286_"
   class="st839"
   points="169.7,118.2 169.9,114.4 161.3,111.4 161.3,115.3 "
   style="fill:#68696d" />
				<polygon
   id="XMLID_8285_"
   class="st107"
   points="160.7,111.1 160.7,106.6 169,109.6 169,114.1 "
   style="fill:#505154" />
				<polygon
   id="XMLID_8284_"
   class="st979"
   points="160.7,106.6 160.7,105.2 169.9,108.6 169,109.6 "
   style="fill:#353638" />
				<path
   id="XMLID_8282_"
   class="st107"
   d="m 160.2,101.5 8.8,2.8 c 0,0 -0.5,-3.7 -1.3,-4.7 L 159,97 c 0,0 0.4,3.9 1.2,4.5 z"
   inkscape:connector-curvature="0"
   style="fill:#505154" />
				<polygon
   id="XMLID_8281_"
   class="st979"
   points="159,97 159,95.7 168.2,98.5 167.7,99.6 "
   style="fill:#353638" />
				<g
   id="XMLID_8272_">
					<rect
   id="XMLID_8280_"
   x="182.8"
   y="30.1"
   class="st702"
   width="5"
   height="3.4000001"
   style="fill:#99845f" />
					<rect
   id="XMLID_8279_"
   x="187.3"
   y="30.1"
   class="st120"
   width="0.30000001"
   height="3.4000001"
   style="fill:#544733" />
					<rect
   id="XMLID_8278_"
   x="183.2"
   y="30.1"
   class="st120"
   width="0.30000001"
   height="3.4000001"
   style="fill:#544733" />
					<rect
   id="XMLID_8276_"
   x="184.2"
   y="30.1"
   class="st120"
   width="0.5"
   height="3.4000001"
   style="fill:#544733" />
					<rect
   id="XMLID_8275_"
   x="186.2"
   y="30.1"
   class="st120"
   width="0.5"
   height="3.4000001"
   style="fill:#544733" />
					<rect
   id="XMLID_8274_"
   x="185.2"
   y="30.1"
   class="st120"
   width="0.5"
   height="3.4000001"
   style="fill:#544733" />
					<ellipse
   id="XMLID_8273_"
   class="st667"
   cx="185.39999"
   cy="30.1"
   rx="2.5"
   ry="0.5"
   style="fill:#c1a880" />
				</g>
				<path
   id="XMLID_8271_"
   class="st733"
   d="m 202.8,117.4 c -0.4,2.4 -2.4,4.4 -4.5,4.4 -2.1,0 -3.5,-2 -3.1,-4.4 0.4,-2.4 2.4,-4.4 4.5,-4.4 2.1,0 3.5,1.9 3.1,4.4 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
				<path
   id="XMLID_8270_"
   class="st101"
   d="m 202.2,117.4 c -0.3,2.1 -2.1,3.8 -3.9,3.8 -1.8,0 -3,-1.7 -2.6,-3.8 z"
   inkscape:connector-curvature="0"
   style="fill:#1d1d1b" />
				
					<linearGradient
   id="XMLID_7822_"
   gradientUnits="userSpaceOnUse"
   x1="178.6514"
   y1="-15938.733"
   x2="193.1826"
   y2="-15938.733"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop94" />
					<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop96" />
				</linearGradient>
				<path
   id="XMLID_8268_"
   class="st40"
   d="m 193.1,123.6 c -0.7,4.5 -4.5,8.1 -8.5,8.1 -4,0 -6.5,-3.6 -5.8,-8.1 0.7,-4.5 4.5,-8.1 8.5,-8.1 4,0 6.5,3.6 5.8,8.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_7822_)" />
				<path
   id="XMLID_8266_"
   class="st733"
   d="m 192.2,123.7 c -0.6,3.8 -3.9,6.9 -7.3,6.9 -3.4,0 -5.6,-3.1 -5,-6.9 0.6,-3.8 3.9,-6.9 7.3,-6.9 3.4,0 5.6,3.1 5,6.9 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
				<path
   id="XMLID_8265_"
   class="st687"
   d="m 179.7,72.9 -2.6,0.3 c 0,0 -2.6,0.1 -2.4,-3.3 l 2.5,-24.9 -6.5,-6.5 v -2.6 c 0,0 13.2,0.5 10,11 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
				
					<linearGradient
   id="XMLID_7823_"
   gradientUnits="userSpaceOnUse"
   x1="189.334"
   y1="-15849.31"
   x2="189.334"
   y2="-15890.946"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop102" />
					<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop104" />
				</linearGradient>
				<path
   id="XMLID_8264_"
   class="st41"
   d="m 180.6,44.7 -2.7,25.2 c 0,0 -0.5,3.4 1.4,3.1 l 26.4,-3.4 c 0,0 2.7,-0.5 2.4,-3.8 l -2.7,-23.5 c 0,0 -0.3,-5.5 -4.3,-6.9 l -7,-2.1 c 0,0 -11.7,-0.8 -23.3,2.8 -0.1,-0.2 11,1.3 9.8,8.6 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_7823_)" />
				<path
   id="XMLID_8262_"
   class="st1071"
   d="m 204.6,43.6 c 0,0 -11.5,-2.5 -23,2.2 l -2.3,19.6 c 0,0 -0.4,2.1 1.8,1.7 l 23.8,-3 c 0,0 1.8,0 1.7,-2.1 z"
   inkscape:connector-curvature="0"
   style="fill:#0d1f30" />
				
					<linearGradient
   id="XMLID_7825_"
   gradientUnits="userSpaceOnUse"
   x1="168.5986"
   y1="-15862.341"
   x2="167.81"
   y2="-15853.439"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#B2B8D1"
   id="stop109" />
					<stop
   offset="1"
   style="stop-color:#545D70"
   id="stop111" />
				</linearGradient>
				<path
   id="XMLID_8261_"
   style="fill:url(#XMLID_7825_);stroke:#383838;stroke-miterlimit:10"
   d="m 159.6,47.3 7,1.7 1.1,-2.6 c 0,0 3.6,-4 9.4,-4.5 0,0 0.4,-1.7 -0.9,-2.1 l -5.5,-1.8 -8.3,2.8 c 0,0.1 -3.5,2 -2.8,6.5 z"
   inkscape:connector-curvature="0" />
				
					<linearGradient
   id="XMLID_7826_"
   gradientUnits="userSpaceOnUse"
   x1="166.5918"
   y1="-15860.197"
   x2="177.27341"
   y2="-15860.197"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
					<stop
   offset="0"
   style="stop-color:#B2B8D1"
   id="stop115" />
					<stop
   offset="1"
   style="stop-color:#545D70"
   id="stop117" />
				</linearGradient>
				<path
   id="XMLID_8260_"
   style="fill:url(#XMLID_7826_);stroke:#383838;stroke-miterlimit:10"
   d="m 166.6,49.1 h 8.7 c 0,0 1.8,0.1 2,-2.8 L 177,41 c 0,0 -10.2,0.6 -10.4,8.1 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_8259_"
   class="st343"
   d="m 165.7,48 c 0,0 0,0 0,0 -0.3,0 -0.6,-0.3 -0.5,-0.6 0,-0.2 0.5,-5.4 8.1,-7.2 0.3,-0.1 0.6,0.1 0.6,0.4 0.1,0.3 -0.1,0.6 -0.4,0.6 -6.8,1.7 -7.2,6.2 -7.3,6.3 0,0.3 -0.2,0.5 -0.5,0.5 z"
   inkscape:connector-curvature="0"
   style="opacity:0.57999998;fill:#ffffff" />
				<path
   id="XMLID_8258_"
   class="st343"
   d="m 167.8,48.4 h 4.1 L 173,45 c 0.1,0.1 -4.1,1.1 -5.2,3.4 z"
   inkscape:connector-curvature="0"
   style="opacity:0.57999998;fill:#ffffff" />
				<polygon
   id="XMLID_8257_"
   class="st343"
   points="208.3,44.1 210.3,44.1 209.7,40.7 "
   style="opacity:0.57999998;fill:#ffffff" />
				<polygon
   id="XMLID_8256_"
   class="st744"
   points="195.4,35.3 184.1,36.3 185.7,38.6 198.3,37.5 "
   style="fill:#666461" />
				<g
   id="XMLID_8246_">
					<polygon
   id="XMLID_8255_"
   class="st0"
   points="183.5,51.6 203,49.7 203,50.3 183.5,52.3 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_8254_"
   class="st0"
   points="183.5,52.6 201.2,50.8 201.2,51.5 183.5,53.3 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_8253_"
   class="st0"
   points="183.5,56.1 203,54.1 203,54.8 183.5,56.7 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_8252_"
   class="st0"
   points="183.5,58.1 203,56.2 203,56.8 183.5,58.8 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_8251_"
   class="st0"
   points="183.5,57.1 201.2,55.3 201.2,56 183.5,57.8 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_8250_"
   class="st0"
   points="183.5,60.2 203,58.2 203,58.9 183.5,60.8 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_8249_"
   class="st0"
   points="183.5,61.1 203,59.2 203,59.8 183.5,61.8 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_8248_"
   class="st0"
   points="183.5,59.2 201.2,57.3 201.2,58 183.5,59.8 "
   style="fill:#46535b" />
				</g>
				<circle
   id="XMLID_8245_"
   class="st687"
   cx="193.7"
   cy="68.199997"
   r="1.9"
   style="fill:#2b2b2b" />
				
					<radialGradient
   id="XMLID_7829_"
   cx="557.33197"
   cy="66.059601"
   r="5.3972998"
   gradientTransform="matrix(0.9218,0,0,1,-319.8284,0)"
   gradientUnits="userSpaceOnUse">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop135" />
					<stop
   offset="1"
   style="stop-color:#707070"
   id="stop137" />
				</radialGradient>
				<ellipse
   id="XMLID_8244_"
   class="st42"
   cx="193.39999"
   cy="68.199997"
   rx="1.4"
   ry="1.6"
   style="fill:url(#XMLID_7829_)" />
				<g
   id="XMLID_8232_">
					<ellipse
   id="XMLID_8243_"
   class="st1084"
   cx="199.3"
   cy="126.4"
   rx="2.2"
   ry="2.5"
   style="fill:#0f0f0f" />
					<ellipse
   id="XMLID_8240_"
   class="st664"
   cx="199.60001"
   cy="126.4"
   rx="1.9"
   ry="2.0999999"
   style="fill:#c12f52" />
					<ellipse
   id="XMLID_8237_"
   class="st651"
   cx="200.10001"
   cy="126.4"
   rx="1.6"
   ry="1.8"
   style="fill:#f9385d" />
					<ellipse
   id="XMLID_8233_"
   class="st718"
   cx="200.7"
   cy="125.7"
   rx="0.60000002"
   ry="0.69999999"
   style="fill:#ff88a4" />
				</g>
				<polygon
   id="XMLID_8231_"
   class="st687"
   points="178.6,92.2 188.2,90.6 188.2,89.3 178.6,90.9 "
   style="fill:#2b2b2b" />
				<polygon
   id="XMLID_8230_"
   class="st687"
   points="201.7,88.4 201.7,87 191.7,88.7 191.7,90 "
   style="fill:#2b2b2b" />
				<polygon
   id="XMLID_8229_"
   class="st687"
   points="178.6,101.8 188.2,100.4 188.2,99 178.6,100.5 "
   style="fill:#2b2b2b" />
				<polygon
   id="XMLID_8228_"
   class="st687"
   points="201.7,98.3 201.7,97 191.7,98.5 191.7,99.8 "
   style="fill:#2b2b2b" />
				<g
   id="XMLID_8173_">
					<path
   id="XMLID_8218_"
   d="m 184.5,94.1 v 1.2 l -0.4,0.5 -0.1,-0.1 V 94 Z M 184,97.7 V 96 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.2,0.1 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z M 186,93.7 184.5,94 184,93.9 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.2,1.3 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.3,0.5 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 v -1.4 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_8210_"
   d="m 184.5,102.9 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z m -0.5,3.7 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.2,0 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.2,1.3 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.3,0.5 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 v -1.4 z"
   inkscape:connector-curvature="0" />
   
					<path
   id="XMLID_8203_"
   d="m 200,100.6 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z m -0.5,3.7 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.2,0 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.2,1.4 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.3,0.4 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 v -1.4 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_8196_"
   d="m 191.2,96.5 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.5,0 -2.1,0.4 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.7,-0.3 z m -0.4,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.1,1.5 0.3,0.2 -0.3,0.3 -1.7,0.3 -0.3,-0.2 0.3,-0.3 z m 0,-0.2 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_8189_"
   d="m 195.1,92.2 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z m -0.5,3.7 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.2,0 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.2,1.3 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.4,0.5 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 V 94 Z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_8182_"
   d="m 198.5,95.6 -0.5,0.1 v -0.5 l 0.5,-0.1 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_8174_"
   d="m 199.6,91.4 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z m -0.5,3.7 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.3,0 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.1,1.5 0.3,0.2 -0.3,0.3 -1.7,0.3 -0.3,-0.2 0.3,-0.3 z m 0,-0.2 V 91 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.4,0.5 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 v -1.4 z"
   inkscape:connector-curvature="0" />
				</g>
				<g
   id="XMLID_8163_">
					<path
   id="XMLID_8164_"
   class="st687"
   d="m 195.1,81.1 v -0.7 l 0.6,-0.1 v -1.9 l -0.6,0.1 v -0.7 c 0,-0.5 -0.4,-0.8 -0.8,-0.7 l -7.4,1.3 c -0.5,0.1 -0.8,0.5 -0.8,1 v 3.4 c 0,0.5 0.4,0.8 0.8,0.7 l 7.4,-1.3 c 0.5,-0.2 0.8,-0.6 0.8,-1.1 z m -8.1,1.7 c -0.2,0 -0.3,-0.1 -0.3,-0.2 v -3.4 c 0,-0.2 0.1,-0.3 0.3,-0.3 l 7.4,-1.3 c 0.2,0 0.3,0.1 0.3,0.2 v 3.4 c 0,0.2 -0.1,0.3 -0.3,0.3 z m 0,-0.3 v -3.3 l 1.2,-0.2 v 3.3 z m 1.5,-0.3 v -3.3 l 1.2,-0.2 V 82 Z M 190,82 v -3.3 l 1.2,-0.2 v 3.3 z m 1.5,-0.3 v -3.3 l 1.2,-0.2 v 3.3 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
				</g>
			</g>
		</g>
		<linearGradient
   id="XMLID_8108_"
   gradientUnits="userSpaceOnUse"
   x1="124.3574"
   y1="75.942902"
   x2="241.5215"
   y2="75.942902">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop162" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop164" />
		</linearGradient>
		
			<circle
   id="XMLID_8155_"
   style="fill:none;stroke:url(#XMLID_8108_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="75.900002"
   r="57.099998" />
	</g>
	<g
   id="XMLID_7467_">
		<circle
   id="XMLID_7472_"
   class="st1015"
   cx="125.6"
   cy="75.900002"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_7468_">
			<rect
   id="XMLID_468_"
   x="118.4"
   y="68.400002"
   class="st739"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(120.4766,82.5742)"
   class="st733 st688 st1094"
   id="text171"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">1</text>

		</g>
	</g>
	<g
   id="checkeo0"
   class="oculto"
   inkscape:label="#XMLID_5057_">
		
			<linearGradient
   id="XMLID_8110_"
   gradientUnits="userSpaceOnUse"
   x1="240.56149"
   y1="-15906.577"
   x2="240.56149"
   y2="-15875.532"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop175" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop177" />
		</linearGradient>
		<path
   id="XMLID_6666_"
   class="st145"
   d="m 240.6,88 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8110_)" />
		<polygon
   id="XMLID_6652_"
   class="st733"
   points="236,75.8 238.4,78 245,70.4 247.5,72.5 238.7,82.8 233.7,78.2 "
   style="fill:#ffffff" />
	</g>
	<g
   id="img2"
   :class="[{'': vistos[1]} ]" @click="darVisto(1)"
   inkscape:label="#XMLID_8474_">
		<linearGradient
   id="XMLID_8115_"
   gradientUnits="userSpaceOnUse"
   x1="124.3564"
   y1="221.25681"
   x2="241.52049"
   y2="221.25681">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop183" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop185" />
		</linearGradient>
		
			<circle
   id="XMLID_8498_"
   style="fill:#ffffff;stroke:url(#XMLID_8115_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="221.3"
   r="57.099998" />
		<g
   id="XMLID_8478_">
			<g
   id="XMLID_8488_">
				<linearGradient
   id="XMLID_8116_"
   gradientUnits="userSpaceOnUse"
   x1="161.7666"
   y1="215.9922"
   x2="204.1123"
   y2="215.9922">
					<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop189" />
					<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop191" />
				</linearGradient>
				<ellipse
   id="XMLID_8495_"
   class="st146"
   cx="182.89999"
   cy="216"
   rx="21.200001"
   ry="21.4"
   style="fill:url(#XMLID_8116_)" />
				<ellipse
   id="XMLID_8492_"
   class="st1015"
   cx="182.89999"
   cy="216"
   rx="10.1"
   ry="11"
   style="fill:#042ab2" />
				<ellipse
   id="XMLID_8489_"
   class="st733"
   cx="190.89999"
   cy="206.3"
   rx="6.8000002"
   ry="6.5999999"
   style="fill:#ffffff" />
			</g>
			<path
   id="XMLID_8485_"
   class="st1015"
   d="m 182.9,255.9 c -22,0 -39.9,-17.9 -39.9,-39.9 0,-22 17.9,-39.9 39.9,-39.9 22,0 39.9,17.9 39.9,39.9 0.1,22 -17.8,39.9 -39.9,39.9 z m 0,-73.6 c -18.6,0 -33.7,15.1 -33.7,33.7 0,18.6 15.1,33.7 33.7,33.7 18.6,0 33.7,-15.1 33.7,-33.7 0,-18.6 -15.1,-33.7 -33.7,-33.7 z"
   inkscape:connector-curvature="0"
   style="fill:#042ab2" />
			<rect
   id="XMLID_8482_"
   x="178.60001"
   y="252.8"
   class="st1015"
   width="8.6000004"
   height="25.5"
   style="fill:#042ab2" />
			<rect
   id="XMLID_8479_"
   x="175"
   y="261"
   class="st366"
   width="15.8"
   height="17.4"
   style="fill:#2368d9" />
		</g>
		<linearGradient
   id="XMLID_8118_"
   gradientUnits="userSpaceOnUse"
   x1="124.3564"
   y1="221.25681"
   x2="241.52049"
   y2="221.25681">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop202" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop204" />
		</linearGradient>
		
			<circle
   id="XMLID_8475_"
   style="fill:none;stroke:url(#XMLID_8118_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="221.3"
   r="57.099998" />
	</g>
	<g
   id="XMLID_7409_">
		<circle
   id="XMLID_7436_"
   class="st1015"
   cx="125.6"
   cy="221.3"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_7426_">
			<rect
   id="XMLID_488_"
   x="118.4"
   y="213.7"
   class="st739"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(120.4746,227.8877)"
   class="st733 st688 st1094"
   id="text211"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">2</text>

		</g>
	</g>
	<g
   id="checkeo1"
   class="oculto"
   inkscape:label="#XMLID_5010_">
		
			<linearGradient
   id="XMLID_8122_"
   gradientUnits="userSpaceOnUse"
   x1="240.5605"
   y1="-16051.892"
   x2="240.5605"
   y2="-16020.847"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop215" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop217" />
		</linearGradient>
		<path
   id="XMLID_5012_"
   style="fill:url(#XMLID_8122_)"
   d="m 240.6,233.3 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0" />
		<polygon
   id="XMLID_5011_"
   class="st733"
   points="236,221.1 238.4,223.4 245,215.7 247.5,217.8 238.7,228.1 233.7,223.5 "
   style="fill:#ffffff" />
	</g>
	<g
   id="img4"
   :class="[{'': vistos[3]} ]" @click="darVisto(3)"
   inkscape:label="#XMLID_8395_">
		<linearGradient
   id="XMLID_8123_"
   gradientUnits="userSpaceOnUse"
   x1="124.3564"
   y1="511.88379"
   x2="241.52049"
   y2="511.88379">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop223" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop225" />
		</linearGradient>
		
			<circle
   id="XMLID_8470_"
   style="fill:#ffffff;stroke:url(#XMLID_8123_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="511.89999"
   r="57.099998" />
		<g
   id="XMLID_8396_">
			<rect
   id="XMLID_8467_"
   x="147"
   y="480.60001"
   class="st719"
   width="72"
   height="67"
   style="fill:#ff9852" />
			<rect
   id="XMLID_8464_"
   x="150"
   y="483.29999"
   class="st733"
   width="66.300003"
   height="60.900002"
   style="fill:#ffffff" />
			<linearGradient
   id="XMLID_8124_"
   gradientUnits="userSpaceOnUse"
   x1="155.7256"
   y1="497.4014"
   x2="211.2529"
   y2="497.4014">
				<stop
   offset="0"
   style="stop-color:#F9385D"
   id="stop231" />
				<stop
   offset="1"
   style="stop-color:#C0255B"
   id="stop233" />
			</linearGradient>
			<rect
   id="XMLID_8463_"
   x="155.7"
   y="492.5"
   class="st148"
   width="55.5"
   height="9.6999998"
   style="fill:url(#XMLID_8124_)" />
			<rect
   id="XMLID_8460_"
   x="207.89999"
   y="473.5"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_8457_"
   x="194.8"
   y="473.5"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_8454_"
   x="181.8"
   y="473.5"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_8451_"
   x="168.8"
   y="473.5"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_8448_"
   x="155.7"
   y="473.5"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<g
   id="XMLID_8432_">
				<rect
   id="XMLID_8445_"
   x="155.7"
   y="505"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8442_"
   x="167"
   y="505"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8439_"
   x="178.39999"
   y="505"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8436_"
   x="189.7"
   y="505"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8433_"
   x="201"
   y="505"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_8416_">
				<rect
   id="XMLID_8429_"
   x="155.7"
   y="517.09998"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8426_"
   x="167"
   y="517.09998"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8423_"
   x="178.39999"
   y="517.09998"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8420_"
   x="189.7"
   y="517.09998"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8417_"
   x="201"
   y="517.09998"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_8400_">
				<rect
   id="XMLID_8413_"
   x="155.7"
   y="529.20001"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8410_"
   x="167"
   y="529.20001"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8407_"
   x="178.39999"
   y="529.20001"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8404_"
   x="189.7"
   y="529.20001"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8401_"
   x="201"
   y="529.20001"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_8397_">
				<linearGradient
   id="XMLID_8136_"
   gradientUnits="userSpaceOnUse"
   x1="168.6006"
   y1="509.9346"
   x2="175.31641"
   y2="509.9346">
					<stop
   offset="0"
   style="stop-color:#F9385D"
   id="stop260" />
					<stop
   offset="1"
   style="stop-color:#C0255B"
   id="stop262" />
				</linearGradient>
				<path
   id="XMLID_8399_"
   class="st149"
   d="m 169.2,513.3 c -0.1,0 -0.3,-0.1 -0.4,-0.2 -0.2,-0.2 -0.2,-0.6 0,-0.8 l 5.6,-5.6 c 0.2,-0.2 0.6,-0.2 0.8,0 0.2,0.2 0.2,0.6 0,0.8 l -5.6,5.6 c -0.1,0.1 -0.3,0.2 -0.4,0.2 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8136_)" />
				
					<linearGradient
   id="XMLID_8137_"
   gradientUnits="userSpaceOnUse"
   x1="-6587.293"
   y1="509.9346"
   x2="-6580.5771"
   y2="509.9346"
   gradientTransform="matrix(-1,0,0,1,-6411.9766,0)">
					<stop
   offset="0"
   style="stop-color:#F9385D"
   id="stop266" />
					<stop
   offset="1"
   style="stop-color:#C0255B"
   id="stop268" />
				</linearGradient>
				<path
   id="XMLID_8398_"
   style="fill:url(#XMLID_8137_)"
   d="m 174.7,513.3 c -0.1,0 -0.3,-0.1 -0.4,-0.2 l -5.6,-5.6 c -0.2,-0.2 -0.2,-0.6 0,-0.8 0.2,-0.2 0.6,-0.2 0.8,0 l 5.6,5.6 c 0.2,0.2 0.2,0.6 0,0.8 -0.1,0.1 -0.2,0.2 -0.4,0.2 z"
   inkscape:connector-curvature="0" />
			</g>
		</g>
	</g>
	<g
   id="XMLID_7396_">
		<circle
   id="XMLID_7406_"
   class="st1015"
   cx="125.6"
   cy="511.89999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_7399_">
			<rect
   id="XMLID_609_"
   x="118.4"
   y="504.39999"
   class="st739"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(120.4746,518.5146)"
   class="st733 st688 st1094"
   id="text277"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">4</text>

		</g>
	</g>
	<g
   id="checkeo3"
   class="oculto"
   inkscape:label="#XMLID_4810_">
		
			<linearGradient
   id="XMLID_8138_"
   gradientUnits="userSpaceOnUse"
   x1="240.5605"
   y1="-16342.52"
   x2="240.5605"
   y2="-16311.475"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop281" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop283" />
		</linearGradient>
		<path
   id="XMLID_4953_"
   class="st150"
   d="m 240.6,524 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8138_)" />
		<polygon
   id="XMLID_4812_"
   class="st733"
   points="236,511.7 238.4,514 245,506.3 247.5,508.5 238.7,518.8 233.7,514.2 "
   style="fill:#ffffff" />
	</g>
	<g
   id="img6"
   :class="[{'': vistos[5]} ]" @click="darVisto(5)"
   inkscape:label="#XMLID_7514_">
		<linearGradient
   id="XMLID_8150_"
   gradientUnits="userSpaceOnUse"
   x1="124.6191"
   y1="802.67291"
   x2="241.7832"
   y2="802.67291">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop289" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop291" />
		</linearGradient>
		
			<circle
   id="XMLID_7743_"
   style="fill:#ffffff;stroke:url(#XMLID_8150_);stroke-width:3;stroke-miterlimit:10"
   cx="183.2"
   cy="802.70001"
   r="57.099998" />
		<g
   id="XMLID_7518_">
			<defs
   id="defs296">
				<circle
   id="XMLID_7519_"
   cx="182.8"
   cy="802.5"
   r="57.200001" />
			</defs>
			<clipPath
   id="XMLID_8151_">
				<use
   xlink:href="#XMLID_7519_"
   style="overflow:visible"
   id="use298"
   x="0"
   y="0"
   width="100%"
   height="100%" />
			</clipPath>
			<g
   id="XMLID_7520_"
   clip-path="url(#XMLID_8151_)">
				<g
   id="XMLID_7521_">
					<ellipse
   id="XMLID_7740_"
   class="st131"
   cx="151"
   cy="815.20001"
   rx="23.1"
   ry="43.400002"
   style="fill:#564a3d" />
					<path
   id="XMLID_7737_"
   class="st1075"
   d="m 154.8,772 v 12.8 c 8.7,0.5 15.7,13.9 15.7,30.4 0,16.5 -7,29.9 -15.7,30.4 v 12.8 c 11.7,-2.1 20.9,-20.6 20.9,-43.2 0,-22.5 -9.2,-41 -20.9,-43.2 z"
   inkscape:connector-curvature="0"
   style="fill:#a8947e" />
					<ellipse
   id="XMLID_7734_"
   class="st1075"
   cx="154.39999"
   cy="815.20001"
   rx="16.200001"
   ry="30.4"
   style="fill:#a8947e" />
					<linearGradient
   id="XMLID_8153_"
   gradientUnits="userSpaceOnUse"
   x1="154.37109"
   y1="848.17291"
   x2="154.37109"
   y2="787.38092">
						<stop
   offset="0"
   style="stop-color:#564A3D"
   id="stop304" />
						<stop
   offset="1"
   style="stop-color:#31180E"
   id="stop306" />
					</linearGradient>
					<ellipse
   id="XMLID_7733_"
   class="st152"
   cx="154.39999"
   cy="815.20001"
   rx="16.200001"
   ry="30.4"
   style="fill:url(#XMLID_8153_)" />
					<rect
   id="XMLID_7730_"
   x="138.7"
   y="828.59998"
   class="st95"
   width="24.6"
   height="17.9"
   style="fill:#b5ac9c" />
					<path
   id="XMLID_7727_"
   class="st1075"
   d="m 154.8,845.6 c -0.2,0 -0.3,0 -0.5,0 -8.9,0 -16.2,-13.6 -16.2,-30.4 0,-16.8 7.2,-30.4 16.2,-30.4 0.2,0 0.3,0 0.5,0 V 772 c -0.7,-0.1 -1.5,-0.2 -2.2,-0.2 -12.8,0 -23.1,19.4 -23.1,43.4 0,24 10.3,43.4 23.1,43.4 0.7,0 1.5,-0.1 2.2,-0.2 z"
   inkscape:connector-curvature="0"
   style="fill:#a8947e" />
					<g
   id="XMLID_7720_">
						<ellipse
   id="XMLID_7724_"
   class="st131"
   cx="155"
   cy="778.90002"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7721_"
   class="st24"
   cx="154.7"
   cy="778.90002"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7713_">
						<ellipse
   id="XMLID_7717_"
   class="st131"
   cx="134.39999"
   cy="815.20001"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7714_"
   class="st24"
   cx="134.10001"
   cy="815.20001"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7706_">
						<ellipse
   id="XMLID_7710_"
   class="st131"
   cx="138.2"
   cy="793.79999"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7707_"
   class="st24"
   cx="137.89999"
   cy="793.79999"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7699_">
						<ellipse
   id="XMLID_7703_"
   class="st131"
   cx="144.7"
   cy="783.5"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7700_"
   class="st24"
   cx="144.39999"
   cy="783.5"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7692_">
						<ellipse
   id="XMLID_7696_"
   class="st131"
   cx="135"
   cy="803.90002"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7693_"
   class="st24"
   cx="134.7"
   cy="803.90002"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7685_">
						<ellipse
   id="XMLID_7689_"
   class="st131"
   cx="134.7"
   cy="825"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7686_"
   class="st24"
   cx="134.3"
   cy="825"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7678_">
						<ellipse
   id="XMLID_7682_"
   class="st131"
   cx="143.5"
   cy="844.40002"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7679_"
   class="st24"
   cx="143.10001"
   cy="844.40002"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7671_">
						<ellipse
   id="XMLID_7675_"
   class="st131"
   cx="164"
   cy="783.5"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7672_"
   class="st24"
   cx="163.7"
   cy="783.5"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7664_">
						<ellipse
   id="XMLID_7668_"
   class="st131"
   cx="169.39999"
   cy="793.79999"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7665_"
   class="st24"
   cx="169.10001"
   cy="793.79999"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7657_">
						<ellipse
   id="XMLID_7661_"
   class="st131"
   cx="138.2"
   cy="834.20001"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7658_"
   class="st24"
   cx="137.89999"
   cy="834.20001"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7650_">
						<ellipse
   id="XMLID_7654_"
   class="st131"
   cx="173.5"
   cy="815.20001"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7651_"
   class="st24"
   cx="173.2"
   cy="815.20001"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7643_">
						<ellipse
   id="XMLID_7647_"
   class="st131"
   cx="155"
   cy="852.29999"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7644_"
   class="st24"
   cx="154.7"
   cy="852.29999"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7626_">
						<ellipse
   id="XMLID_7640_"
   class="st939"
   cx="166.7"
   cy="837.5"
   rx="10"
   ry="11.5"
   style="fill:#9e7f66" />
						<ellipse
   id="XMLID_7637_"
   class="st728"
   cx="171.2"
   cy="837.5"
   rx="7.0999999"
   ry="14.8"
   style="fill:#ffe2ca" />
						<path
   id="XMLID_7634_"
   class="st709"
   d="m 161.1,877.9 c -0.8,0 -1.5,-0.4 -1.9,-1.2 -1.4,-2.9 -13.2,-28.2 -7,-37.4 1.2,-1.7 3.5,-3.7 8,-3.5 1.2,0.1 2,1.1 2,2.2 0,1.1 -1.1,2 -2.2,2 -2.7,-0.2 -3.7,0.8 -4.2,1.6 -3.7,5.5 2.6,23.3 7.3,33.3 0.5,1 0.1,2.3 -1,2.8 -0.4,0.1 -0.7,0.2 -1,0.2 z"
   inkscape:connector-curvature="0"
   style="fill:#605147" />
						<ellipse
   id="XMLID_7631_"
   class="st914"
   cx="172"
   cy="837.5"
   rx="7.0999999"
   ry="14.8"
   style="fill:#cca885" />
						<linearGradient
   id="XMLID_8156_"
   gradientUnits="userSpaceOnUse"
   x1="172.0146"
   y1="829.30182"
   x2="172.0146"
   y2="846.77417">
							<stop
   offset="0"
   style="stop-color:#564A3D"
   id="stop352" />
							<stop
   offset="1"
   style="stop-color:#31180E"
   id="stop354" />
						</linearGradient>
						<ellipse
   id="XMLID_7630_"
   style="fill:url(#XMLID_8156_)"
   cx="172"
   cy="837.5"
   rx="3.5"
   ry="8.6000004" />
						<path
   id="XMLID_7627_"
   class="st95"
   d="m 158,835.5 c 0,0 1.9,2.4 0,5 h 3.2 c 0,0 1.3,-0.8 1.3,-2.5 0,0 -0.1,-1.9 -1.6,-2.5 z"
   inkscape:connector-curvature="0"
   style="fill:#b5ac9c" />
					</g>
					<g
   id="XMLID_7522_">
						<ellipse
   id="XMLID_7623_"
   class="st62"
   cx="199.39999"
   cy="925.09998"
   rx="46.299999"
   ry="5"
   style="opacity:0.38999999;fill:#042ab2" />
						<path
   id="XMLID_7622_"
   class="st721"
   d="m 177,805 c 0,0 -4.4,-0.9 -5.7,-1.2 -1.3,-0.3 -3.5,-1 -3.5,-1 0,0 -0.3,-0.5 0.2,-0.6 0.5,-0.1 2.6,0.3 2.6,0.3 0,0 -3.5,-0.9 -3.6,-1.2 -0.1,-0.3 0.2,-0.5 0.8,-0.4 0.6,0.1 3.1,0.6 3.1,0.6 0,0 -4.1,-1.1 -4,-1.5 0,-0.4 0.3,-0.7 1.1,-0.4 0.8,0.2 3.1,0.8 3.1,0.8 0,0 -3.2,-1.3 -3.2,-1.5 0,-0.1 -0.3,-0.6 0.4,-0.7 0.7,-0.1 5.5,1.4 5.5,1.4 l -0.5,-0.7 c 0,0 -1.3,-0.5 -1.3,-0.7 0,-0.2 0.1,-0.8 0.9,-0.6 0.8,0.1 3,1.3 3,1.3 l 2.7,1.5 z"
   inkscape:connector-curvature="0"
   style="fill:#ffb236" />
						<g
   id="XMLID_7618_">
							<g
   id="g363">
								<path
   id="XMLID_7772_"
   class="st14"
   d="m 200.3,810.1 -1.4,2.9 c -0.8,1.7 -2.8,2.5 -4.5,1.8 -5.3,-2 -12.7,-5.9 -19.5,-9.4 l 3.3,-5.9 c 6.8,3.6 15.5,8.5 22.1,10.6 z"
   inkscape:connector-curvature="0"
   style="fill:#106489" />
							</g>
						</g>
						<g
   id="XMLID_7610_">
							<g
   id="g369">
								<g
   id="XMLID_7762_">
									<path
   class="st14"
   d="m 199.9,810.8 -6.7,-0.6 c 6.5,-21.7 8.9,-22.7 9.3,-23.1 l 8.2,1.3 -0.9,2 c 0,0.1 -9.6,17.4 -9.9,20.4 z"
   id="path366"
   inkscape:connector-curvature="0"
   style="fill:#106489" />
								</g>
							</g>
						</g>
						<path
   id="XMLID_7607_"
   class="st12"
   d="m 226.9,787.5 c 0,0 0.1,2.7 0.4,11 0.6,13.9 0.9,36.2 0,37.2 -1.4,1.5 -27.4,-1 -27.4,-1 0,0 2,-42.2 2.5,-47.4 l 11.3,-3.4 c 0,0 11.1,3.5 13.2,3.6 z"
   inkscape:connector-curvature="0"
   style="fill:#105477" />
						<path
   id="XMLID_7606_"
   class="st67"
   d="m 208.8,786.4 -0.8,-8.9 c 2.9,-1.2 6.4,-3.1 9.4,-2.7 0.4,2.4 0.5,6.5 0.9,9 0.1,0.3 -0.1,-1.1 0.2,1.3 z"
   inkscape:connector-curvature="0"
   style="fill:#e8b897" />
						<polygon
   id="XMLID_7603_"
   class="st12"
   points="227.3,835.8 200.2,834.5 191.2,871.2 190.6,919.6 196.5,920.8 200.3,872.9 210.8,848.7 212.9,848.7 215.1,872.7 222.9,920.2 228.9,920 224.8,870.9 "
   style="fill:#105477" />
						<path
   id="XMLID_7602_"
   class="st687"
   d="m 222.2,919.2 0.2,1.8 c 0,0 -6.1,2.4 -4.9,4.7 0.3,0.5 1.6,0.5 2.6,0.5 1,0 4.1,-0.8 4.1,-0.8 l 1.3,0.3 3.1,-0.3 0.3,-6.5 c 0,-0.2 -3.6,0.7 -6.7,0.3 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<path
   id="XMLID_7601_"
   class="st687"
   d="m 189.9,918.8 0.4,1.8 c 0,0 -6.8,1.7 -5.7,4.1 0.2,0.5 1.8,0.7 3,0.8 1.1,0.1 4.8,-0.3 4.8,-0.3 l 0.6,0.3 2.6,-0.1 1,-6.5 c 0,0 -3.3,0.7 -6.7,-0.1 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<polygon
   id="XMLID_7598_"
   class="st14"
   points="219.8,787.4 218.6,782.6 213.5,787.1 216.8,791.3 "
   style="fill:#106489" />
						<polygon
   id="XMLID_7595_"
   class="st14"
   points="209,783 207.2,787.1 210.3,790.9 213.5,787 "
   style="fill:#106489" />
						<path
   id="XMLID_7592_"
   class="st1099"
   d="m 199.7,833.5 c 0,0 15.1,4 28.2,0.4 l -0.2,3.3 c 0,0 -13.5,3.8 -28.6,0 z"
   inkscape:connector-curvature="0"
   style="fill:#444444" />
						<path
   id="XMLID_7591_"
   class="st687"
   d="m 209.5,835 1.6,0.2 0.6,-0.4 1.8,0.2 -0.5,4.8 -1.9,-0.2 -0.5,-0.4 -1.6,-0.2 c 0,0 0.2,-2.9 0.5,-4 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<path
   id="XMLID_7590_"
   class="st687"
   d="m 216.9,839.1 h -1.6 l -0.5,0.5 H 213 l -0.1,-4.8 h 1.9 l 0.5,0.3 h 1.6 c 0,0 0.2,2.9 0,4 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<path
   id="XMLID_7589_"
   class="st687"
   d="m 217.4,839.1 c 0,0 0,-2.8 -0.1,-4 l 1.1,-0.1 v 0.6 h -0.5 l 0.2,2.8 h 0.8 v 0.6 c 0,0 -1.1,0.2 -1.5,0.1 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<path
   id="XMLID_7588_"
   class="st687"
   d="m 209.3,835 c 0,0 -0.6,2.8 -0.6,3.9 l -1.2,-0.1 v -0.6 h 0.5 l 0.4,-2.7 h -0.5 l 0.1,-0.6 c 0.1,0.1 0.9,0.1 1.3,0.1 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<g
   id="XMLID_7582_">
							<circle
   id="XMLID_7587_"
   class="st29"
   cx="213.2"
   cy="793.59998"
   r="0.69999999"
   style="fill:#132c33" />
							<circle
   id="XMLID_7586_"
   class="st29"
   cx="212.5"
   cy="802.5"
   r="0.69999999"
   style="fill:#132c33" />
							<circle
   id="XMLID_7585_"
   class="st29"
   cx="211.7"
   cy="812.29999"
   r="0.69999999"
   style="fill:#132c33" />
							<circle
   id="XMLID_7584_"
   class="st29"
   cx="211.7"
   cy="821.20001"
   r="0.69999999"
   style="fill:#132c33" />
							<circle
   id="XMLID_7583_"
   class="st29"
   cx="211.7"
   cy="830.20001"
   r="0.69999999"
   style="fill:#132c33" />
						</g>
						<path
   id="XMLID_7581_"
   class="st733"
   d="m 199.4,822.4 c 2.1,0.2 3.6,1.4 2.6,2.6 -0.5,0.6 -1.4,0.9 -2.4,1.1 -0.8,0.2 -1.6,0.1 -2.4,0.3 -2.3,0.5 -2.7,1.3 -3.2,2.4 -0.6,1.3 -1.2,2.7 -3.8,2.9 -3,0.2 -4.4,-1.1 -5.4,-2.5 -2,-2.7 -6.8,-3.6 -9.6,-5.9 -2,-1.6 -2.7,-3.4 -2.3,-5.4 0.7,-3.4 1.8,-6.5 0.8,-10 -0.5,-1.6 -2.7,-4.1 -0.4,-5.5 0.2,-0.1 0.5,0.1 0.3,0.2 -2,1.2 0.4,4.4 0.7,5.9 0.5,2 0.5,4 0.1,6 -0.4,2 -1.6,4.1 -0.9,6.1 0.8,2.2 3.6,3.8 6.6,5.1 1.6,0.7 3.3,1.4 4.4,2.4 0.9,0.9 1.1,1.9 2.4,2.6 2.4,1.4 5.5,0.8 6.5,-1.1 0.5,-1 0.6,-2.2 2.1,-2.9 0.5,-0.3 1.1,-0.4 1.8,-0.5 0.5,-0.1 1.1,-0.1 1.6,-0.2 1.2,0 1.8,-0.5 1.6,-1.5 1.5,-1.1 1.1,-1.7 -1,-1.8 -0.5,0 -0.4,-0.3 -0.1,-0.3 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
						
							<rect
   id="XMLID_7580_"
   x="171"
   y="793.90002"
   transform="matrix(-0.02479649,0.9997,-0.9997,-0.02479649,995.7956,668.6438)"
   class="st206"
   width="1.5"
   height="52.200001"
   style="fill:#8f9d9e" />
						
							<rect
   id="XMLID_7579_"
   x="195.89999"
   y="813"
   transform="rotate(92.144163,197.03506,820.84467)"
   class="st1089"
   width="2.2"
   height="15.7"
   style="fill:#404949" />
						<g
   id="XMLID_7572_">
							
								<rect
   id="XMLID_7578_"
   x="167.8"
   y="794.20001"
   transform="matrix(-0.7895,0.6137,-0.6137,-0.7895,796.6093,1327.6058)"
   class="st1078"
   width="5.6999998"
   height="12.3"
   style="fill:#a8a8a8" />
							<circle
   id="XMLID_7577_"
   class="st82"
   cx="169.10001"
   cy="797.90002"
   r="1.7"
   style="fill:#b0d882" />
							<g
   id="XMLID_7573_">
								
									<rect
   id="XMLID_7576_"
   x="169.5"
   y="801"
   transform="matrix(-0.7909,0.6119,-0.6119,-0.7909,797.6613,1330.4879)"
   class="st1038"
   width="4.0999999"
   height="1.1"
   style="fill:#707070" />
								
									<rect
   id="XMLID_7575_"
   x="170.5"
   y="802.29999"
   transform="matrix(-0.7909,0.6119,-0.6119,-0.7909,800.2477,1332.1931)"
   class="st1038"
   width="4.0999999"
   height="1.1"
   style="fill:#707070" />
								
									<rect
   id="XMLID_7574_"
   x="171.5"
   y="803.59998"
   transform="matrix(-0.7911,0.6117,-0.6117,-0.7911,802.6799,1334.0801)"
   class="st1038"
   width="4.0999999"
   height="1.1"
   style="fill:#707070" />
							</g>
						</g>
						<path
   id="XMLID_7571_"
   class="st721"
   d="m 172.7,797.6 -2,1.5 c 0,0 0.7,1.8 2.8,-0.1"
   inkscape:connector-curvature="0"
   style="fill:#ffb236" />
						<rect
   id="XMLID_7568_"
   x="202.39999"
   y="802.5"
   class="st1086"
   width="6.8000002"
   height="8.5"
   style="fill:#0f4b63" />
						<rect
   id="XMLID_7565_"
   x="215.8"
   y="802.5"
   class="st1086"
   width="6.8000002"
   height="8.5"
   style="fill:#0f4b63" />
						<polygon
   id="XMLID_7562_"
   class="st14"
   points="209.9,800.7 201.9,800.7 201,803.9 209.9,803.9 "
   style="fill:#106489" />
						<polygon
   id="XMLID_7559_"
   class="st14"
   points="223.9,800.7 215.9,800.7 215,803.9 223.9,803.9 "
   style="fill:#106489" />
						<g
   id="XMLID_7548_">
							<path
   id="XMLID_7556_"
   class="st14"
   d="m 217.8,814.2 5.7,-26.3 c 8.9,-2.2 5.7,7.7 5.7,7.7 0,0 -4.9,21.5 -6,23.3 -0.1,0.4 -5.4,-4.7 -5.4,-4.7 z"
   inkscape:connector-curvature="0"
   style="fill:#106489" />
							<g
   id="XMLID_7552_">
								<g
   id="g407">
									<path
   id="XMLID_7761_"
   class="st721"
   d="m 197.4,819 -1.7,0.4 -3.6,1.5 c -0.3,0 -0.9,0.4 -0.7,0.7 v 0 c 0.1,0.2 0.3,0.5 1.2,0.4 l 1.4,-0.6 c 0,0 0.5,-0.2 -1.7,1.8 -0.2,0.2 -0.6,0.8 -0.1,1 0.5,0.2 2.2,-1 2.2,-1 l 0.1,0.2 -1.7,1.6 c -0.3,0.3 -0.8,0.9 -0.4,1 0.3,0.1 0.9,-0.2 0.9,-0.2 l 1.7,-1.3 0.1,0.2 c 0,0 -1.6,1 -1.4,1.6 0.1,0.4 0.7,0.2 1,0 l 1,-0.9 0.1,0.1 c 0,0 -0.4,0.4 -0.2,0.6 0.2,0.3 0.8,0.1 1,0 1,-0.4 2.5,-2.2 2.5,-2.2 0,0 2.1,-1.7 1.4,-3.2 -0.7,-1.5 -1.3,-1.8 -3.1,-1.7 z"
   inkscape:connector-curvature="0"
   style="fill:#ffb236" />
								</g>
							</g>
							<path
   id="XMLID_7549_"
   class="st14"
   d="m 223.3,819.2 c -8.4,1.9 -24.6,5.1 -24.6,5.1 l -0.9,-6 21.4,-5.1 c 2.2,2.4 4.1,4.2 4.1,6 z"
   inkscape:connector-curvature="0"
   style="fill:#106489" />
						</g>
						<g
   id="XMLID_7523_">
							<path
   id="XMLID_7547_"
   class="st67"
   d="m 199,771.6 c -0.7,-0.8 -1.7,-0.6 -2,0.3 -0.2,0.9 0.3,2.1 1.1,2.6 0.8,0.6 1.7,0.7 2.4,0.4"
   inkscape:connector-curvature="0"
   style="fill:#e8b897" />
							<path
   id="XMLID_7546_"
   class="st687"
   d="m 196.1,764.2 c 0,0 5,18.4 11.8,20.1 l 0.3,-0.6 c 0,0 -5,-3.1 -10.4,-19.9 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_7545_"
   class="st558"
   d="m 210.2,784.8 c 2.5,-0.4 2.6,-0.9 3,-1.2 0.6,-0.5 5.4,-8.6 5.3,-9.5 -0.3,-4.4 -0.6,-6.5 -1.6,-10.8 -0.7,-3 -1.6,-6.3 -3.8,-8.2 -2.7,-2.4 -6.5,-2.1 -9.8,-1.5 -1.5,0.3 -3.9,1.1 -5.3,2.5 -1.1,1.2 -1.8,5.1 -1.5,6.3 1.7,7.2 2.8,9.3 5.7,16.2 1.3,3.2 7.3,6.3 8,6.2"
   inkscape:connector-curvature="0"
   style="fill:#f4c4a4" />
							<path
   id="XMLID_7544_"
   class="st23"
   d="m 207.9,767.7 c -3.6,-3.7 2.3,-6.9 4.5,-1.1 0,0 -0.4,0.7 -1.9,1.1 -1.7,0.4 -2.6,0 -2.6,0 z"
   inkscape:connector-curvature="0"
   style="fill:#e0b192" />
							<path
   id="XMLID_7543_"
   class="st23"
   d="m 199.6,769.7 c -3.6,-3.7 2.3,-6.9 4.5,-1.1 0,0 1,6.1 1,6.4 0.2,1.5 -5.5,-5.3 -5.5,-5.3 z"
   inkscape:connector-curvature="0"
   style="fill:#e0b192" />
							<path
   id="XMLID_7542_"
   class="st67"
   d="m 217.1,767.1 c 0.1,-1.1 1.2,-1.8 2.1,-1.6 0.9,0.2 1.7,1.3 1.8,2.3 0.1,1.1 -0.3,2.1 -1,2.8 -0.4,0.4 -0.9,0.8 -1.5,0.8 -0.6,0 -1.2,-0.4 -1.4,-1"
   inkscape:connector-curvature="0"
   style="fill:#e8b897" />
							<path
   id="XMLID_7541_"
   class="st130"
   d="m 204,768.1 c 0,0 0.2,0.8 0.5,2.1 0.3,1.2 0.6,2.9 0.8,4.5 0.1,0.4 0.1,0.9 0.3,1.1 0.2,0.2 0.5,0.3 0.9,0.3 0.7,-0.1 1.4,-0.3 2,-0.5 0.6,-0.2 1.1,-0.3 1.5,-0.4 0.4,-0.1 0.6,-0.1 0.6,-0.1 0,0 -0.2,0.1 -0.5,0.2 -0.3,0.1 -0.8,0.3 -1.4,0.6 -0.6,0.2 -1.3,0.5 -2.1,0.7 -0.4,0.1 -1,0.1 -1.3,-0.4 -0.3,-0.4 -0.3,-0.9 -0.4,-1.3 -0.3,-1.7 -0.5,-3.3 -0.6,-4.6 -0.1,-1.3 -0.3,-2.2 -0.3,-2.2 z"
   inkscape:connector-curvature="0"
   style="fill:#56361a" />
							<path
   id="XMLID_7540_"
   class="st687"
   d="m 211.1,777.9 c 0,0.5 -0.2,1.4 -1.9,1.9 -1.9,0.6 -2.4,-0.3 -2.7,-0.8 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_7539_"
   class="st687"
   d="m 210.6,764.1 c 0,0 -0.3,-0.2 -0.8,-0.3 -0.2,-0.1 -0.5,-0.2 -0.8,-0.2 -0.3,-0.1 -0.6,-0.1 -0.8,-0.1 0,0 -0.1,0 -0.1,0 H 208 c -0.1,0 -0.1,0 -0.2,0.1 -0.1,0.1 -0.3,0.1 -0.4,0.2 -0.3,0.1 -0.5,0.3 -0.7,0.4 -0.4,0.3 -0.7,0.5 -0.7,0.5 0,0 0,-0.4 0.3,-0.9 0.1,-0.2 0.4,-0.5 0.7,-0.7 0.1,-0.1 0.3,-0.2 0.5,-0.3 0.1,0 0.2,-0.1 0.3,-0.1 0.1,0 0.2,-0.1 0.3,-0.1 0.5,-0.1 0.9,0.1 1.2,0.2 0.3,0.2 0.6,0.3 0.8,0.5 0.2,0.2 0.3,0.4 0.4,0.5 0.1,0.1 0.1,0.3 0.1,0.3 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_7538_"
   class="st687"
   d="m 202.4,765.9 c 0,0 -0.4,-0.1 -0.8,-0.1 -0.2,0 -0.5,-0.1 -0.8,-0.1 -0.3,0 -0.6,0 -0.8,0.1 0,0 -0.1,0 -0.1,0 l -0.1,0.1 c -0.1,0 -0.1,0.1 -0.2,0.1 -0.1,0.1 -0.2,0.1 -0.4,0.2 -0.2,0.2 -0.4,0.4 -0.6,0.5 -0.3,0.3 -0.6,0.6 -0.6,0.6 0,0 -0.1,-0.4 0.1,-0.9 0.1,-0.3 0.3,-0.6 0.5,-0.8 0.1,-0.1 0.2,-0.3 0.4,-0.4 0.1,-0.1 0.2,-0.1 0.3,-0.2 0.1,0 0.2,-0.1 0.3,-0.1 0.4,-0.2 0.9,-0.1 1.2,0 0.3,0.1 0.6,0.2 0.9,0.4 0.2,0.1 0.4,0.3 0.5,0.4 0.2,0.1 0.2,0.2 0.2,0.2 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_7537_"
   class="st122"
   d="M 218.5,765.2"
   inkscape:connector-curvature="0"
   style="fill:none;stroke:#ffffff;stroke-miterlimit:10" />
							<path
   id="XMLID_7536_"
   class="st733"
   d="m 207.9,767.7 c 0.1,-0.9 2.7,-2.3 4.5,-1.1 0,0 -0.4,0.7 -1.9,1.1 -1.7,0.4 -2.6,0 -2.6,0 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
							
								<ellipse
   id="XMLID_7535_"
   transform="matrix(-0.9713,0.238,-0.238,-0.9713,595.2476,1462.3425)"
   class="st687"
   cx="209.39999"
   cy="767.09998"
   rx="1"
   ry="0.80000001"
   style="fill:#2b2b2b" />
							
								<ellipse
   id="XMLID_7534_"
   transform="matrix(-0.9712,0.2381,-0.2381,-0.9712,593.6721,1462.4548)"
   class="st733"
   cx="208.5"
   cy="767.09998"
   rx="0.40000001"
   ry="0.30000001"
   style="fill:#ffffff" />
							<path
   id="XMLID_7533_"
   class="st687"
   d="m 214.6,760.7 c 0,0 5.3,15.9 -1.4,22.8 0,0 8.2,-4.7 3.5,-22.6 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_7532_"
   class="st733"
   d="m 199.9,769.6 c 0.1,-0.9 2.2,-2.2 3.7,-0.9 0,0 -0.3,0.7 -1.6,1 -1.3,0.3 -2.1,-0.1 -2.1,-0.1 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
							
								<circle
   id="XMLID_7531_"
   transform="matrix(-0.9714,0.2376,-0.2376,-0.9714,579.0223,1468.4939)"
   class="st687"
   cx="201"
   cy="769.09998"
   r="0.80000001"
   style="fill:#2b2b2b" />
							
								<ellipse
   id="XMLID_7530_"
   transform="matrix(-0.9712,0.2381,-0.2381,-0.9712,577.9762,1468.3682)"
   class="st733"
   cx="200.3"
   cy="769.09998"
   rx="0.40000001"
   ry="0.30000001"
   style="fill:#ffffff" />
							<path
   id="XMLID_7529_"
   class="st687"
   d="m 207.9,784.3 c 0,0 0.9,-1.9 6.1,-1.3 0,0 -0.6,1.5 -3,2.1 -2.4,0.5 -3.4,-0.5 -3.1,-0.8 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<polygon
   id="XMLID_7528_"
   class="st942"
   points="218,761.5 213.7,762 214.6,766 218.4,764.2 "
   style="fill:#303233" />
							<polygon
   id="XMLID_7527_"
   class="st942"
   points="218.5,774.1 215.8,776.3 215.3,772.2 218.7,772.1 "
   style="fill:#303233" />
							<path
   id="XMLID_7526_"
   class="st98"
   d="m 194.7,763.4 c 0,0 -1,-8.7 1.6,-10.7 v -1.8 c 0,0 6.7,-3.2 14.1,-2 7.4,1.3 8.1,10.8 8.1,10.8 z"
   inkscape:connector-curvature="0"
   style="fill:#eaeaea" />
							<polygon
   id="XMLID_7525_"
   class="st915"
   points="193.8,762.2 218.4,758.8 218.4,760.6 194.8,764.7 "
   style="fill:#cccccc" />
							<path
   id="XMLID_7524_"
   class="st1097"
   d="m 219.6,764.7 -7.3,-0.2 -6.8,2 c 0,0 -0.7,2.6 -2.2,0.8 l -6.3,2 1.6,3.4 5.8,-1.7 c 0,0 -0.3,-2.9 0.2,-2.6 0.5,0.3 1.6,2 1.6,2 l 7.9,-2 0.7,-2.4 5,-0.7 z"
   inkscape:connector-curvature="0"
   style="opacity:0.51000001;fill:#ffffff;enable-background:new" />
						</g>
					</g>
				</g>
			</g>
		</g>
		<linearGradient
   id="XMLID_8158_"
   gradientUnits="userSpaceOnUse"
   x1="124.6191"
   y1="802.67291"
   x2="241.7832"
   y2="802.67291">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop441" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop443" />
		</linearGradient>
		
			<circle
   id="XMLID_7515_"
   style="fill:none;stroke:url(#XMLID_8158_);stroke-width:3;stroke-miterlimit:10"
   cx="183.2"
   cy="802.70001"
   r="57.099998" />
	</g>
	<g
   id="XMLID_7380_">
		<circle
   id="XMLID_7392_"
   class="st1015"
   cx="125.6"
   cy="802.5"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_7382_">
			<rect
   id="XMLID_7775_"
   x="118.4"
   y="795"
   class="st739"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(120.4746,809.1426)"
   class="st733 st688 st1094"
   id="text450"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">6</text>

		</g>
	</g>
	<g
   id="checkeo5"
   class="oculto"
   inkscape:label="#XMLID_4778_">
		
			<linearGradient
   id="XMLID_8234_"
   gradientUnits="userSpaceOnUse"
   x1="240.56149"
   y1="-16633.145"
   x2="240.56149"
   y2="-16602.1"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop454" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop456" />
		</linearGradient>
		<path
   id="XMLID_4780_"
   style="fill:url(#XMLID_8234_)"
   d="m 240.6,814.6 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0" />
		<polygon
   id="XMLID_4779_"
   class="st733"
   points="236,802.4 238.4,804.6 245,796.9 247.5,799.1 238.7,809.4 233.7,804.8 "
   style="fill:#ffffff" />
	</g>
	<g
   id="img8"
   :class="[{'': vistos[7]} ]" @click="darVisto(7)"
   inkscape:label="#XMLID_8308_">
		<linearGradient
   id="XMLID_8236_"
   gradientUnits="userSpaceOnUse"
   x1="124.3564"
   y1="1093.1396"
   x2="241.52049"
   y2="1093.1396">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop462" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop464" />
		</linearGradient>
		
			<circle
   id="XMLID_8391_"
   style="fill:#ffffff;stroke:url(#XMLID_8236_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="1093.1"
   r="57.099998" />
		<g
   id="XMLID_8309_">
			<rect
   id="XMLID_8388_"
   x="147.39999"
   y="1061.8"
   class="st719"
   width="72"
   height="67"
   style="fill:#ff9852" />
			<rect
   id="XMLID_8385_"
   x="150.39999"
   y="1064.5"
   class="st733"
   width="66.300003"
   height="60.900002"
   style="fill:#ffffff" />
			<linearGradient
   id="XMLID_8238_"
   gradientUnits="userSpaceOnUse"
   x1="156.12399"
   y1="1078.6562"
   x2="211.6514"
   y2="1078.6562">
				<stop
   offset="0"
   style="stop-color:#F9385D"
   id="stop470" />
				<stop
   offset="1"
   style="stop-color:#C0255B"
   id="stop472" />
			</linearGradient>
			<rect
   id="XMLID_8384_"
   x="156.10001"
   y="1073.8"
   style="fill:url(#XMLID_8238_)"
   width="55.5"
   height="9.6999998" />
			<rect
   id="XMLID_8381_"
   x="208.3"
   y="1054.8"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_8378_"
   x="195.2"
   y="1054.8"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_8375_"
   x="182.2"
   y="1054.8"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_8372_"
   x="169.2"
   y="1054.8"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_8369_"
   x="156.10001"
   y="1054.8"
   class="st1013"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<g
   id="XMLID_8351_">
				<rect
   id="XMLID_8366_"
   x="156.10001"
   y="1086.3"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8362_"
   x="167.39999"
   y="1086.3"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8359_"
   x="178.8"
   y="1086.3"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8355_"
   x="190.10001"
   y="1086.3"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8352_"
   x="201.39999"
   y="1086.3"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_8331_">
				<rect
   id="XMLID_8346_"
   x="156.10001"
   y="1098.4"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8342_"
   x="167.39999"
   y="1098.4"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8339_"
   x="178.8"
   y="1098.4"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8335_"
   x="190.10001"
   y="1098.4"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8332_"
   x="201.39999"
   y="1098.4"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_8312_">
				<rect
   id="XMLID_8328_"
   x="156.10001"
   y="1110.5"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8324_"
   x="167.39999"
   y="1110.5"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8321_"
   x="178.8"
   y="1110.5"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8317_"
   x="190.10001"
   y="1110.5"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_8313_"
   x="201.39999"
   y="1110.5"
   class="st1023"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<path
   id="XMLID_8311_"
   class="st64"
   d="m 161,1108 c -0.4,0 -0.8,-0.2 -1,-0.5 l -3.2,-4.1 c -0.4,-0.6 -0.4,-1.4 0.2,-1.8 0.6,-0.4 1.4,-0.3 1.8,0.2 l 2.1,2.7 3.9,-5.9 c 0.4,-0.6 1.2,-0.8 1.8,-0.4 0.6,0.4 0.8,1.2 0.4,1.8 l -4.9,7.3 c -0.2,0.5 -0.6,0.7 -1.1,0.7 0.1,0 0.1,0 0,0 z"
   inkscape:connector-curvature="0"
   style="fill:#4d8e02" />
		</g>
	</g>
	<g
   id="XMLID_7294_">
		<circle
   id="XMLID_7375_"
   class="st1015"
   cx="125.6"
   cy="1093.1"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_7295_">
			<rect
   id="XMLID_7776_"
   x="118.4"
   y="1085.6"
   class="st739"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(120.4746,1099.7705)"
   class="st733 st688 st1094"
   id="text504"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">8</text>

		</g>
	</g>
	<g
   id="checkeo7"
   class="oculto"
   inkscape:label="#XMLID_4739_">
		
			<linearGradient
   id="XMLID_8239_"
   gradientUnits="userSpaceOnUse"
   x1="240.5605"
   y1="-16923.773"
   x2="240.5605"
   y2="-16892.729"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop508" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop510" />
		</linearGradient>
		<path
   id="XMLID_4750_"
   style="fill:url(#XMLID_8239_)"
   d="m 240.6,1105.2 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0" />
		<polygon
   id="XMLID_4740_"
   class="st733"
   points="236,1093 238.4,1095.2 245,1087.6 247.5,1089.7 238.7,1100 233.7,1095.4 "
   style="fill:#ffffff" />
	</g>
	<g
   id="img3"
   :class="[{'': vistos[2]} ]" @click="darVisto(2)"
   inkscape:label="#XMLID_8112_">
		<linearGradient
   id="XMLID_8241_"
   gradientUnits="userSpaceOnUse"
   x1="124.3574"
   y1="366.57129"
   x2="241.5215"
   y2="366.57129">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop516" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop518" />
		</linearGradient>
		
			<circle
   id="XMLID_8149_"
   style="fill:#ffffff;stroke:url(#XMLID_8241_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="366.60001"
   r="57.099998" />
		<g
   id="XMLID_8113_">
			<linearGradient
   id="XMLID_8242_"
   gradientUnits="userSpaceOnUse"
   x1="221.3662"
   y1="325.62701"
   x2="221.3662"
   y2="395.5285">
				<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop522" />
				<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop524" />
			</linearGradient>
			<path
   id="XMLID_8146_"
   style="fill:url(#XMLID_8242_)"
   d="m 216.8,332.6 c -1.1,-1.1 -2.9,-1.1 -4,0 -1.1,1.1 -1.1,2.9 0,4 8,8 12.4,18.6 12.4,29.8 0,11.2 -4.4,21.9 -12.4,29.8 -1.1,1.1 -1.1,2.9 0,4 1.1,1.1 2.9,1.1 4,0 9,-9 14,-21 14,-33.8 0,-12.8 -5,-24.7 -14,-33.8 z m 0,0"
   inkscape:connector-curvature="0" />
			<linearGradient
   id="XMLID_8305_"
   gradientUnits="userSpaceOnUse"
   x1="211.127"
   y1="325.62601"
   x2="211.127"
   y2="395.5289">
				<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop528" />
				<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop530" />
			</linearGradient>
			<path
   id="XMLID_8141_"
   style="fill:url(#XMLID_8305_)"
   d="m 208.3,341.1 c -1.1,-1.1 -2.9,-1.1 -4,0 -1.1,1.1 -1.1,2.9 0,4 5.7,5.7 8.8,13.3 8.8,21.4 0,8.1 -3.1,15.7 -8.8,21.4 -1.1,1.1 -1.1,2.9 0,4 1.1,1.1 2.9,1.1 4,0 6.8,-6.8 10.5,-15.8 10.5,-25.3 0,-9.7 -3.8,-18.7 -10.5,-25.5 z m 0,0"
   inkscape:connector-curvature="0" />
			<path
   id="XMLID_8134_"
   class="st420"
   d="m 199.8,349.6 c -1.1,-1.1 -2.9,-1.1 -4,0 -1.1,1.1 -1.1,2.9 0,4 3.4,3.4 5.3,8 5.3,12.9 0,4.9 -1.9,9.4 -5.3,12.9 -1.1,1.1 -1.1,2.9 0,4 1.1,1.1 2.9,1.1 4,0 4.5,-4.5 7,-10.5 7,-16.8 0,-6.3 -2.5,-12.5 -7,-17 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:#23cad9" />
			<linearGradient
   id="XMLID_8306_"
   gradientUnits="userSpaceOnUse"
   x1="144.5127"
   y1="325.62701"
   x2="144.5127"
   y2="395.5285">
				<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop535" />
				<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop537" />
			</linearGradient>
			<path
   id="XMLID_8130_"
   style="fill:url(#XMLID_8306_)"
   d="m 140.7,366.5 c 0,-11.3 4.4,-21.9 12.4,-29.8 1.1,-1.1 1.1,-2.9 0,-4 -1.1,-1.1 -2.9,-1.1 -4,0 -9,9 -14,21 -14,33.8 0,12.8 5,24.8 14,33.8 1.1,1.1 2.9,1.1 4,0 1.1,-1.1 1.1,-2.9 0,-4 -8,-8 -12.4,-18.6 -12.4,-29.8 z m 0,0"
   inkscape:connector-curvature="0" />
			<linearGradient
   id="XMLID_8307_"
   gradientUnits="userSpaceOnUse"
   x1="154.752"
   y1="325.62601"
   x2="154.752"
   y2="395.5289">
				<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop541" />
				<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop543" />
			</linearGradient>
			<path
   id="XMLID_8127_"
   style="fill:url(#XMLID_8307_)"
   d="m 152.7,366.5 c 0,-8.1 3.1,-15.7 8.8,-21.4 1.1,-1.1 1.1,-2.9 0,-4 -1.1,-1.1 -2.9,-1.1 -4,0 -6.8,6.8 -10.5,15.8 -10.5,25.3 0,9.6 3.7,18.6 10.5,25.3 1.1,1.1 2.9,1.1 4,0 1.1,-1.1 1.1,-2.9 0,-4 -5.6,-5.6 -8.8,-13.2 -8.8,-21.2 z m 0,0"
   inkscape:connector-curvature="0" />
			<path
   id="XMLID_8121_"
   class="st420"
   d="m 170.1,349.6 c -1.1,-1.1 -2.9,-1.1 -4,0 -4.5,4.5 -7,10.5 -7,16.8 0,6.3 2.5,12.3 7,16.8 1.1,1.1 2.9,1.1 4,0 1.1,-1.1 1.1,-2.9 0,-4 -3.4,-3.4 -5.3,-8 -5.3,-12.9 0,-4.9 1.9,-9.4 5.3,-12.9 1.1,-0.9 1.1,-2.7 0,-3.8 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:#23cad9" />
			<path
   id="XMLID_8114_"
   class="st420"
   d="m 182.9,354.7 c -6.5,0 -11.8,5.3 -11.8,11.8 0,6.5 5.3,11.8 11.8,11.8 6.5,0 11.8,-5.3 11.8,-11.8 0,-6.6 -5.3,-11.8 -11.8,-11.8 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:#23cad9" />
		</g>
	</g>
	<g
   id="XMLID_7459_">
		<circle
   id="XMLID_7464_"
   class="st1015"
   cx="125.6"
   cy="366.5"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_7460_">
			<rect
   id="XMLID_7778_"
   x="118.4"
   y="359"
   class="st739"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(120.4775,373.1572)"
   class="st733 st688 st1094"
   id="text553"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">3</text>

		</g>
	</g>
	<g
   id="checkeo2"
   class="oculto"
   inkscape:label="#XMLID_4676_">
		
			<linearGradient
   id="XMLID_8314_"
   gradientUnits="userSpaceOnUse"
   x1="240.56149"
   y1="-16197.16"
   x2="240.56149"
   y2="-16166.115"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop557" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop559" />
		</linearGradient>
		<path
   id="XMLID_4684_"
   style="fill:url(#XMLID_8314_)"
   d="m 240.6,378.6 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0" />
		<polygon
   id="XMLID_4678_"
   class="st733"
   points="236,366.4 238.4,368.6 245,361 247.5,363.1 238.7,373.4 233.7,368.8 "
   style="fill:#ffffff" />
	</g>
	<g
   id="img5"
   :class="[{'': vistos[4]} ]" @click="darVisto(4)"
   inkscape:label="#XMLID_7747_">
		<linearGradient
   id="XMLID_8315_"
   gradientUnits="userSpaceOnUse"
   x1="124.3574"
   y1="657.19818"
   x2="241.5215"
   y2="657.19818">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop565" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop567" />
		</linearGradient>
		
			<circle
   id="XMLID_8107_"
   style="fill:#ffffff;stroke:url(#XMLID_8315_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="657.20001"
   r="57.099998" />
		<g
   id="XMLID_7749_">
			<path
   id="XMLID_8106_"
   class="st2"
   d="m 159.5,627.2 c 0.2,-2.6 0.9,-5.1 2.2,-7.3 1.3,-2.2 5.1,-7 7.6,-3.6 1.3,1.8 1.7,4.3 1.4,6.4 -0.3,2.5 -2.2,4.6 -2.5,7.1 -0.3,2.8 1.6,4.8 4.3,4.1 3,-0.8 4.2,-4.2 5.2,-6.9 0.7,-2.1 0.7,-4 0.8,-6.1 0.2,-3 2.1,-4.9 4.2,-7 3.1,-3.1 7.4,-5.7 11.9,-3.7 2.3,1 4.2,2.8 6.1,4.3 1.1,0.8 3.2,1.9 1.5,3.3 -0.3,0.2 -1.3,0.5 -1.6,0.7 -1.4,0.7 -2.6,1.8 -3.5,3.2 -2.7,4.1 -2.1,9.2 -1.5,13.8 0,0.3 1.9,-0.1 1.9,-0.5 -0.6,-4.7 -1.2,-10 1.7,-14 1.2,-1.6 2.3,-2 4,-2.9 0.2,-0.1 0.6,-0.1 0.8,-0.3 0.9,-0.9 1,-1.4 0,-2.5 -4.9,-5.3 -11.5,-8.2 -18.1,-4.8 -3.1,1.6 -6.2,4.5 -8.1,7.4 -1.1,1.7 -1.1,3.1 -1.1,5.1 -0.1,2.8 -1,5.3 -2.3,7.8 -0.5,0.9 -1.6,2.7 -2.9,2.2 -0.8,-0.3 -1.3,-2 -1.3,-2.8 -0.2,-2.5 1.8,-4.6 2.3,-6.9 0.7,-2.8 0.2,-7.9 -3.1,-9.1 -2.2,-0.8 -4.7,0.9 -6.2,2.3 -3.3,2.9 -5.2,6.9 -5.5,11.3 -0.1,0.1 1.7,-0.1 1.8,-0.6 z"
   inkscape:connector-curvature="0"
   style="fill:#aaaaaa" />
			<g
   id="XMLID_7791_">
				<g
   id="XMLID_8101_">
					<linearGradient
   id="XMLID_8319_"
   gradientUnits="userSpaceOnUse"
   x1="197.2256"
   y1="628.19342"
   x2="197.2256"
   y2="701.99933">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop572" />
						<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop574" />
					</linearGradient>
					<path
   id="XMLID_8105_"
   style="fill:url(#XMLID_8319_)"
   d="m 214.7,632.5 c -5.4,-3 -17.5,-3.1 -17.5,-3.1 0,0 -12.1,0 -17.5,3.1 0,0 -2.8,9.7 -1.6,17.6 0,0 6.4,19.7 2.7,36.8 0,0 -1.1,9.8 3.7,12.8 l 12.7,1 12.7,-1 c 4.8,-3 3.7,-12.8 3.7,-12.8 -3.7,-17.1 2.7,-36.8 2.7,-36.8 1.2,-7.9 -1.6,-17.6 -1.6,-17.6 z"
   inkscape:connector-curvature="0" />
					<linearGradient
   id="XMLID_8320_"
   gradientUnits="userSpaceOnUse"
   x1="197.2256"
   y1="700.86041"
   x2="197.2256"
   y2="629.53442">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop578" />
						<stop
   offset="1"
   style="stop-color:#707070"
   id="stop580" />
					</linearGradient>
					<path
   id="XMLID_8104_"
   class="st165"
   d="m 214,633.7 c -5.2,-2.9 -16.8,-3 -16.8,-3 0,0 -11.6,0 -16.8,3 0,0 -2.7,9.4 -1.5,17 0,0 6.1,19 2.5,35.5 0,0 -1,9.5 3.6,12.3 l 12.2,0.9 12.1,-0.9 c 4.6,-2.8 3.6,-12.3 3.6,-12.3 -3.6,-16.5 2.5,-35.5 2.5,-35.5 1.3,-7.6 -1.4,-17 -1.4,-17 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8320_)" />
					<linearGradient
   id="XMLID_8322_"
   gradientUnits="userSpaceOnUse"
   x1="197.2256"
   y1="699.51862"
   x2="197.2256"
   y2="628.46472">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop584" />
						<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop586" />
					</linearGradient>
					<path
   id="XMLID_8102_"
   class="st166"
   d="m 213.4,634.3 c -5,-2.9 -16.1,-2.9 -16.1,-2.9 0,0 -11.2,0 -16.1,2.9 0,0 -2.6,9.2 -1.5,16.7 0,0 5.9,18.7 2.4,34.9 0,0 -1,9.3 3.4,12.1 l 11.7,0.9 11.7,-0.9 c 4.4,-2.8 3.4,-12.1 3.4,-12.1 -3.4,-16.2 2.4,-34.9 2.4,-34.9 1.3,-7.5 -1.3,-16.7 -1.3,-16.7 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8322_)" />
				</g>
				<path
   id="XMLID_8100_"
   class="st1044"
   d="m 216.3,646.3 v 0.9 c -1.9,0.6 -2,-0.8 -2,-0.8 1.2,-3.5 -1.1,-5.9 -1.1,-5.9 l -2,-2.3 c -1.4,-1.7 3.7,-3.7 3.7,-3.7 l 0.2,1.1 c 1.4,-1.3 -0.4,-4.7 -0.4,-4.7 -2.7,-2.3 -5,-0.4 -5,-0.4 l 0.9,0.8 c 1.3,0.3 -0.3,2.3 -0.3,2.3 -1.4,2.3 -2.7,1 -2.7,1 -4.6,-6.1 -5.7,-5.5 -5.7,-5.5 h -4.7 -4.7 c 0,0 -1.1,-0.6 -5.7,5.5 0,0 -1.3,1.3 -2.7,-1 0,0 -1.6,-2 -0.3,-2.3 l 0.9,-0.8 c 0,0 -2.3,-1.8 -5,0.4 0,0 -1.8,3.4 -0.4,4.7 l 0.2,-1.1 c 0,0 5.1,2 3.7,3.7 l -2,2.3 c 0,0 -2.3,2.4 -1.1,5.9 0,0 -0.1,1.4 -2,0.8 v -0.9 c 0,0 -1.6,0.8 -1,2.6 l 0.6,2.3 c 0,0 0.9,0.9 2.8,0.9 0,0 1.4,-0.2 1.8,4.4 0,0 0.3,3.5 -0.5,3.6 l -1.2,0.3 -0.3,-1.6 c 0,0 -0.7,0.1 -0.8,1.9 l 0.2,2.8 c 0,0 0.4,1.4 1.6,1.2 0,0 2.2,-0.4 2.3,1.4 l 0.2,4.6 c 0,0 0.1,1.6 -1,1.6 h -1 l -0.1,-2.4 c 0,0 -1.1,-0.2 -1.1,1.1 v 4.1 c 0,0 0.5,1.6 2.2,1.4 0,0 1.4,-0.2 1.4,2.3 l -0.2,3.6 c 0,0 -0.3,1.7 -1.9,1.2 0,0 -0.7,-0.1 -0.7,-0.6 l 0.3,-2.7 c 0,0 -1.2,-0.4 -1.4,0.9 l -0.5,5 0.5,0.9 c 0,0 -0.5,3.9 0.4,7.2 0,0 1.1,4.8 4.1,6 l 1.1,-0.6 c 0,0 5.8,0.8 11.2,0.6 5.3,0.2 11.2,-0.6 11.2,-0.6 l 1.1,0.6 c 3,-1.2 4.1,-6 4.1,-6 0.9,-3.2 0.4,-7.2 0.4,-7.2 l 0.5,-0.9 -0.5,-5 c -0.2,-1.3 -1.4,-0.9 -1.4,-0.9 l 0.3,2.7 c 0.1,0.5 -0.7,0.6 -0.7,0.6 -1.6,0.5 -1.9,-1.2 -1.9,-1.2 l -0.2,-3.6 c 0,-2.4 1.4,-2.3 1.4,-2.3 1.7,0.1 2.2,-1.4 2.2,-1.4 V 671 c 0,-1.2 -1.1,-1.1 -1.1,-1.1 l -0.1,2.4 h -1 c -1,0 -1,-1.6 -1,-1.6 l 0.2,-4.6 c 0.1,-1.8 2.3,-1.4 2.3,-1.4 1.2,0.2 1.6,-1.2 1.6,-1.2 l 0.2,-2.8 c -0.1,-1.7 -0.8,-1.9 -0.8,-1.9 l -0.3,1.6 -1.2,-0.3 c -0.8,-0.1 -0.5,-3.6 -0.5,-3.6 0.3,-4.6 1.8,-4.4 1.8,-4.4 1.9,0 2.8,-0.9 2.8,-0.9 l 0.6,-2.3 c 0.9,-1.8 -0.8,-2.6 -0.8,-2.6 z"
   inkscape:connector-curvature="0"
   style="fill:#727272" />
				<linearGradient
   id="XMLID_8323_"
   gradientUnits="userSpaceOnUse"
   x1="197.22659"
   y1="702.55658"
   x2="197.22659"
   y2="628.67969">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop592" />
					<stop
   offset="1"
   style="stop-color:#4D494D"
   id="stop594" />
				</linearGradient>
				<path
   id="XMLID_8099_"
   class="st167"
   d="m 216.5,646.6 v 0.9 c -1.9,0.6 -2,-0.8 -2,-0.8 1.3,-3.5 -1.1,-6 -1.1,-6 l -2,-2.3 c -1.4,-1.7 3.8,-3.7 3.8,-3.7 l 0.2,1.1 c 1.4,-1.4 -0.4,-4.8 -0.4,-4.8 -2.7,-2.3 -5,-0.4 -5,-0.4 l 0.9,0.8 c 1.3,0.3 -0.3,2.3 -0.3,2.3 -1.4,2.3 -2.7,1 -2.7,1 -4.6,-6.2 -5.7,-5.6 -5.7,-5.6 h -4.8 -4.8 c 0,0 -1.1,-0.6 -5.7,5.6 0,0 -1.4,1.3 -2.7,-1 0,0 -1.6,-2 -0.3,-2.3 l 0.9,-0.8 c 0,0 -2.3,-1.9 -5,0.4 0,0 -1.8,3.4 -0.4,4.8 l 0.2,-1.1 c 0,0 5.1,2 3.8,3.7 l -2,2.3 c 0,0 -2.3,2.5 -1.1,6 0,0 -0.1,1.5 -2,0.8 v -0.9 c 0,0 -1.7,0.8 -1,2.6 l 0.6,2.3 c 0,0 0.9,0.9 2.8,0.9 0,0 1.5,-0.2 1.8,4.5 0,0 0.3,3.5 -0.5,3.6 l -1.2,0.3 -0.3,-1.6 c 0,0 -0.7,0.2 -0.8,1.9 l 0.2,2.9 c 0,0 0.4,1.4 1.7,1.2 0,0 2.2,-0.4 2.3,1.4 l 0.2,4.7 c 0,0 0.1,1.6 -1,1.6 h -1 l -0.1,-2.5 c 0,0 -1.1,-0.2 -1.1,1.1 v 4.2 c 0,0 0.5,1.6 2.2,1.4 0,0 1.4,-0.2 1.4,2.3 l -0.2,3.7 c 0,0 -0.3,1.7 -1.9,1.2 0,0 -0.7,-0.1 -0.7,-0.6 l 0.3,-2.8 c 0,0 -1.2,-0.4 -1.4,0.9 l -0.5,5 0.5,0.9 c 0,0 -0.5,4 0.4,7.3 0,0 1.1,4.8 4.1,6.1 l 1.1,-0.6 c 0,0 5.9,0.8 11.3,0.6 5.4,0.2 11.3,-0.6 11.3,-0.6 l 1.1,0.6 c 3.1,-1.2 4.1,-6.1 4.1,-6.1 0.9,-3.3 0.4,-7.3 0.4,-7.3 l 0.5,-0.9 -0.5,-5 c -0.2,-1.4 -1.4,-0.9 -1.4,-0.9 l 0.3,2.8 c 0.1,0.5 -0.7,0.6 -0.7,0.6 -1.6,0.5 -1.9,-1.2 -1.9,-1.2 l -0.2,-3.7 c 0,-2.5 1.4,-2.3 1.4,-2.3 1.7,0.1 2.2,-1.4 2.2,-1.4 v -4.2 c 0,-1.2 -1.1,-1.1 -1.1,-1.1 l -0.1,2.5 h -1 c -1,0 -1,-1.6 -1,-1.6 l 0.2,-4.7 c 0.1,-1.8 2.3,-1.4 2.3,-1.4 1.2,0.2 1.7,-1.2 1.7,-1.2 l 0.2,-2.9 c -0.1,-1.8 -0.8,-1.9 -0.8,-1.9 l -0.3,1.6 -1.2,-0.3 c -0.8,-0.1 -0.5,-3.6 -0.5,-3.6 0.3,-4.7 1.8,-4.5 1.8,-4.5 2,0 2.8,-0.9 2.8,-0.9 l 0.6,-2.3 c 0.4,-1.8 -1.2,-2.6 -1.2,-2.6 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8323_)" />
				<g
   id="XMLID_8093_">
					<path
   id="XMLID_8098_"
   class="st635"
   d="m 213.3,642.6 -7.4,-8.1 c -2.1,-2.7 -4.2,-2.4 -4.2,-2.4 h -4.5 -4.5 c 0,0 -2.1,-0.2 -4.2,2.4 l -7.4,8.1 c 0,0 -2,2.7 1.5,4.9 0,0 6.4,2.9 14.5,2.6 8.1,0.4 14.5,-2.6 14.5,-2.6 3.7,-2.2 1.7,-4.9 1.7,-4.9 z"
   inkscape:connector-curvature="0"
   style="fill:#282828" />
					<path
   id="XMLID_8094_"
   class="st745"
   d="m 198.6,650.5 c -0.4,0 -0.9,0 -1.4,0 -8.1,0.4 -14.6,-2.6 -14.7,-2.6 v 0 c -1.3,-0.8 -2,-1.8 -2.2,-2.9 -0.3,-1.4 0.6,-2.6 0.6,-2.6 v 0 l 7.4,-8.1 c 2.1,-2.7 4.2,-2.6 4.5,-2.6 h 8.9 c 0.3,0 2.4,-0.1 4.5,2.6 l 7.4,8.1 c 0,0 0.9,1.2 0.6,2.6 -0.2,1.1 -0.9,2 -2.2,2.9 v 0 c -0.2,0 -6,2.6 -13.4,2.6 z m -1.4,-0.7 v 0 c 7.7,0.3 13.9,-2.3 14.3,-2.5 1.1,-0.7 1.7,-1.5 1.9,-2.4 0.2,-1.1 -0.4,-1.9 -0.5,-2 l -7.4,-8.1 c -1.9,-2.5 -3.8,-2.3 -3.9,-2.3 v 0 h -9 c -0.1,0 -2,-0.2 -3.9,2.3 v 0 l -7.4,8.1 c -0.1,0.1 -0.7,1 -0.5,2 0.2,0.9 0.8,1.7 1.9,2.4 0.6,0.1 6.9,2.8 14.5,2.5 z"
   inkscape:connector-curvature="0"
   style="fill:#666666" />
				</g>
				<g
   id="XMLID_7831_">
					<path
   id="XMLID_8036_"
   class="st978"
   d="m 184.8,660.1 c 0,0 11.4,1.9 24.9,0 l -0.7,-1.5 h -23.5 z"
   inkscape:connector-curvature="0"
   style="fill:#353535" />
					<path
   id="XMLID_8033_"
   class="st75"
   d="m 185.5,658.6 -0.7,1.5 c 0,0 -2.5,-2.5 -2.3,-11.4 l 2.4,3.3 z"
   inkscape:connector-curvature="0"
   style="fill:#4f4d4f" />
					<path
   id="XMLID_8030_"
   class="st75"
   d="m 209,658.6 0.7,1.5 c 0,0 2.5,-2.5 2.3,-11.4 l -2.4,3.3 z"
   inkscape:connector-curvature="0"
   style="fill:#4f4d4f" />
					<path
   id="XMLID_8027_"
   class="st710"
   d="m 197.2,651 c -8.5,0.4 -14.6,-2.3 -14.6,-2.3 0.1,1.4 1.6,3.3 1.6,3.3 2.5,1.3 13,0.8 13,0.8 0,0 10.5,0.4 13,-0.8 0,0 1.5,-1.9 1.6,-3.3 0,0 -6.1,2.6 -14.6,2.3 z"
   inkscape:connector-curvature="0"
   style="fill:#605c60" />
					<linearGradient
   id="XMLID_8325_"
   gradientUnits="userSpaceOnUse"
   x1="197.125"
   y1="659.38672"
   x2="197.125"
   y2="651.87762">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop605" />
						<stop
   offset="1"
   style="stop-color:#4D494D"
   id="stop607" />
					</linearGradient>
					<path
   id="XMLID_8026_"
   class="st168"
   d="m 197.7,652.4 v 0 c -0.2,0 -0.4,0 -0.6,0 -0.2,0 -0.4,0 -0.6,0 v 0 c -5.8,0 -12.4,-0.4 -12.4,-0.4 0.1,2.6 1.3,6.6 1.3,6.6 h 11.1 1.1 11.1 c 0,0 1.3,-4.1 1.3,-6.6 0.1,0 -6.6,0.4 -12.3,0.4 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8325_)" />
					<rect
   id="XMLID_7837_"
   x="186.3"
   y="653.40002"
   class="st635"
   width="14.7"
   height="4.3000002"
   style="fill:#282828" />
					<g
   id="XMLID_7832_">
						<circle
   id="XMLID_7836_"
   class="st635"
   cx="205.60001"
   cy="655.5"
   r="2.0999999"
   style="fill:#282828" />
						<path
   id="XMLID_7833_"
   class="st673"
   d="m 205.6,657.8 c -1.3,0 -2.3,-1 -2.3,-2.3 0,-1.3 1,-2.3 2.3,-2.3 1.3,0 2.3,1 2.3,2.3 0,1.3 -1.1,2.3 -2.3,2.3 z m 0,-4.3 c -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 1.1,0 2,-0.9 2,-2 -0.1,-1.1 -0.9,-2 -2,-2 z"
   inkscape:connector-curvature="0"
   style="fill:#93837a" />
					</g>
				</g>
				<path
   id="XMLID_7828_"
   class="st710"
   d="m 206,679.9 h -17.6 c -1.4,0 -2.5,-1.1 -2.5,-2.5 v -8.6 c 0,-2.8 2.2,-5 5,-5 h 12.5 c 2.8,0 5,2.2 5,5 v 8.6 c 0.1,1.4 -1,2.5 -2.4,2.5 z"
   inkscape:connector-curvature="0"
   style="fill:#605c60" />
				<linearGradient
   id="XMLID_8326_"
   gradientUnits="userSpaceOnUse"
   x1="197.2256"
   y1="664.03418"
   x2="197.2256"
   y2="679.1571">
					<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop617" />
					<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop619" />
				</linearGradient>
				<path
   id="XMLID_7827_"
   class="st169"
   d="M 202.5,678.5 H 192 c -2.8,0 -5,-2.2 -5,-5 v -4.1 c 0,-2.8 2.2,-5 5,-5 h 10.5 c 2.8,0 5,2.2 5,5 v 4.1 c 0,2.8 -2.3,5 -5,5 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8326_)" />
				<path
   id="XMLID_7824_"
   class="st710"
   d="m 185.6,680.6 h 23.2 l 1.1,6.8 c 0,0 -12.1,5.8 -25.5,0 z"
   inkscape:connector-curvature="0"
   style="fill:#605c60" />
				<path
   id="XMLID_7821_"
   class="st734"
   d="M 184.5,687.2 H 210 l 1.2,6.8 c 0,0 -13.3,5.8 -28,0 z"
   inkscape:connector-curvature="0"
   style="opacity:0.27000002;fill:#605c60" />
				<path
   id="XMLID_7818_"
   class="st1020"
   d="m 202,632.8 h -4.6 -0.3 -4.6 c 0,0 -2.8,0.4 -3.7,2.7 l 2.6,7.5 h 5.6 0.3 5.6 l 2.6,-7.5 c -0.7,-2.3 -3.5,-2.7 -3.5,-2.7 z"
   inkscape:connector-curvature="0"
   style="fill:#3a3a3a" />
				<rect
   id="XMLID_7815_"
   x="192.60001"
   y="635.5"
   class="st693"
   width="9.1999998"
   height="3.5999999"
   style="fill:#c7ee95" />
				<circle
   id="XMLID_7814_"
   class="st101"
   cx="197.2"
   cy="646.5"
   r="1.7"
   style="fill:#1d1d1b" />
				<g
   id="XMLID_7809_">
					<linearGradient
   id="XMLID_8329_"
   gradientUnits="userSpaceOnUse"
   x1="197.2256"
   y1="689.95612"
   x2="197.2256"
   y2="681.01758">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop628" />
						<stop
   offset="1"
   style="stop-color:#4D494D"
   id="stop630" />
					</linearGradient>
					<path
   id="XMLID_7813_"
   class="st170"
   d="m 186.3,681 h 22 l 1.1,5.7 c 0,0 -11.5,4.9 -24.2,0 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8329_)" />
					<path
   id="XMLID_7810_"
   class="st635"
   d="m 197,689 c -3.6,0 -7.7,-0.5 -11.9,-2.2 l -0.1,-0.1 1.2,-6 h 22.3 l 1.1,6 -0.1,0.1 c -0.2,0.1 -5.3,2.2 -12.5,2.2 z m -11.7,-2.4 c 11.7,4.4 22.5,0.5 23.8,0 l -1,-5.4 h -21.7 z"
   inkscape:connector-curvature="0"
   style="fill:#282828" />
				</g>
				<g
   id="XMLID_7806_">
					
						<rect
   id="XMLID_7808_"
   x="192.5"
   y="680.79999"
   transform="matrix(0.954,0.2998,-0.2998,0.954,214.1784,-26.2534)"
   class="st635"
   width="0.40000001"
   height="7.9000001"
   style="fill:#282828" />
					
						<rect
   id="XMLID_7807_"
   x="197.89999"
   y="684.59998"
   transform="matrix(0.304,0.9527,-0.9527,0.304,792.8489,284.3649)"
   class="st635"
   width="7.9000001"
   height="0.40000001"
   style="fill:#282828" />
				</g>
				<g
   id="XMLID_7792_">
					<polygon
   id="XMLID_7803_"
   class="st710"
   points="189.4,686 187.1,683.1 191.6,683.1 "
   style="fill:#605c60" />
					<polygon
   id="XMLID_7800_"
   class="st710"
   points="205.6,683.1 203.4,686 207.8,686 "
   style="fill:#605c60" />
					<g
   id="XMLID_7793_">
						<g
   id="g643">
							<path
   id="XMLID_8091_"
   class="st710"
   d="m 197.9,682.6 v 0.7 c 0.7,0.3 1.1,0.9 1.1,1.6 0,1 -0.8,1.8 -1.8,1.8 -1,0 -1.8,-0.8 -1.8,-1.8 0,-0.8 0.5,-1.4 1.1,-1.6 v -0.7 c -1,0.3 -1.8,1.2 -1.8,2.3 0,1.3 1.1,2.4 2.4,2.4 1.3,0 2.4,-1.1 2.4,-2.4 0.1,-1.1 -0.6,-2 -1.6,-2.3 z"
   inkscape:connector-curvature="0"
   style="fill:#605c60" />
							<rect
   id="XMLID_8037_"
   x="196.8"
   y="681.90002"
   class="st710"
   width="0.80000001"
   height="3.4000001"
   style="fill:#605c60" />
						</g>
					</g>
				</g>
			</g>
			<g
   id="XMLID_7750_">
				<ellipse
   id="XMLID_7788_"
   class="st427"
   cx="158.60001"
   cy="698"
   rx="11.1"
   ry="3.2"
   style="fill:#f2f2f2" />
				<rect
   id="XMLID_7781_"
   x="156.89999"
   y="623.59998"
   class="st76"
   width="3.5999999"
   height="3.9000001"
   style="fill:#4f514c" />
				<rect
   id="XMLID_7777_"
   x="159.7"
   y="635.90002"
   class="st76"
   width="8.8000002"
   height="2"
   style="fill:#4f514c" />
				<path
   id="XMLID_7774_"
   class="st1054"
   d="m 158.7,699 v 0 c -4.6,0 -8.3,-0.8 -8.3,-3 v -41.4 c 0,-4.6 3.8,-8.3 8.3,-8.3 v 0 c 4.6,0 8.3,3.8 8.3,8.3 V 696 c 0.1,2.8 -3.7,3 -8.3,3 z"
   inkscape:connector-curvature="0"
   style="fill:#a4bcc1" />
				<ellipse
   id="XMLID_7771_"
   class="st3"
   cx="158.7"
   cy="647.79999"
   rx="5.0999999"
   ry="2"
   style="fill:#7c9da5" />
				<rect
   id="XMLID_7760_"
   x="156"
   y="626.29999"
   class="st659"
   width="5.5999999"
   height="21.5"
   style="fill:#918e91" />
				<g
   id="XMLID_7751_">
					<g
   id="XMLID_7755_">
						<circle
   id="XMLID_7759_"
   class="st733"
   cx="158.7"
   cy="637"
   r="4.5999999"
   style="fill:#ffffff" />
						<path
   id="XMLID_7756_"
   class="st101"
   d="m 158.7,642 c -2.7,0 -4.9,-2.2 -4.9,-4.9 0,-2.7 2.2,-4.9 4.9,-4.9 2.7,0 4.9,2.2 4.9,4.9 0,2.7 -2.1,4.9 -4.9,4.9 z m 0,-9.3 c -2.4,0 -4.3,1.9 -4.3,4.3 0,2.4 1.9,4.3 4.3,4.3 2.4,0 4.3,-1.9 4.3,-4.3 0,-2.4 -1.9,-4.3 -4.3,-4.3 z"
   inkscape:connector-curvature="0"
   style="fill:#1d1d1b" />
					</g>
					<circle
   id="XMLID_7752_"
   class="st81"
   cx="158.7"
   cy="637"
   r="1.4"
   style="fill:#b0cad1" />
				</g>
			</g>
		</g>
	</g>
	<g
   id="XMLID_7451_">
		<circle
   id="XMLID_7456_"
   class="st1015"
   cx="125.6"
   cy="657.29999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_7452_">
			<rect
   id="XMLID_7779_"
   x="118.4"
   y="649.79999"
   class="st739"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(120.4756,663.9189)"
   class="st733 st688 st1094"
   id="text664"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">5</text>

		</g>
	</g>
	<g
   id="checkeo4"
   class="oculto"
   inkscape:label="#XMLID_4660_">
		
			<linearGradient
   id="XMLID_8330_"
   gradientUnits="userSpaceOnUse"
   x1="240.56149"
   y1="-16487.922"
   x2="240.56149"
   y2="-16456.877"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop668" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop670" />
		</linearGradient>
		<path
   id="XMLID_4670_"
   class="st171"
   d="m 240.6,669.4 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8330_)" />
		<polygon
   id="XMLID_4669_"
   class="st733"
   points="236,657.1 238.4,659.4 245,651.7 247.5,653.9 238.7,664.2 233.7,659.6 "
   style="fill:#ffffff" />
	</g>
	<g
   id="img7"
   :class="[{'': vistos[6]} ]" @click="darVisto(6)"
   inkscape:label="#XMLID_7475_">
		<linearGradient
   id="XMLID_8333_"
   gradientUnits="userSpaceOnUse"
   x1="124.3574"
   y1="947.8252"
   x2="241.5215"
   y2="947.8252">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop676" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop678" />
		</linearGradient>
		
			<circle
   id="XMLID_7510_"
   style="fill:#ffffff;stroke:url(#XMLID_8333_);stroke-width:3;stroke-miterlimit:10"
   cx="182.89999"
   cy="947.79999"
   r="57.099998" />
		<g
   id="XMLID_7476_">
			<linearGradient
   id="XMLID_8334_"
   gradientUnits="userSpaceOnUse"
   x1="184.2188"
   y1="902.34381"
   x2="184.2188"
   y2="992.96802">
				<stop
   offset="0"
   style="stop-color:#FFE888"
   id="stop682" />
				<stop
   offset="0.9789"
   style="stop-color:#FFA370"
   id="stop684" />
			</linearGradient>
			<rect
   id="XMLID_7509_"
   x="151.89999"
   y="909.20001"
   class="st173"
   width="64.699997"
   height="81.5"
   style="fill:url(#XMLID_8334_)" />
			<rect
   id="XMLID_7506_"
   x="156.8"
   y="914.90002"
   class="st733"
   width="54.799999"
   height="70.900002"
   style="fill:#ffffff" />
			<rect
   id="XMLID_7505_"
   x="166.2"
   y="906.90002"
   class="st675"
   width="36"
   height="12.8"
   style="fill:#939fa3" />
			<circle
   id="XMLID_7504_"
   class="st675"
   cx="184.2"
   cy="908"
   r="6.5999999"
   style="fill:#939fa3" />
			<rect
   id="XMLID_7503_"
   x="163.89999"
   y="945.20001"
   class="st35"
   width="40.700001"
   height="31.5"
   style="fill:#e2e2e2" />
			<rect
   id="XMLID_7502_"
   x="163.89999"
   y="937.20001"
   class="st706"
   width="40.700001"
   height="6"
   style="fill:#c9c9c9" />
			<g
   id="XMLID_7477_">
				<path
   id="XMLID_7499_"
   d="m 163.8,934.6 v -4.8 h 1.6 c 0.2,0 0.5,0 0.7,0.1 0.2,0 0.4,0.1 0.6,0.2 0.2,0.1 0.3,0.3 0.4,0.4 0.1,0.1 0.1,0.4 0.1,0.7 0,0.4 -0.1,0.7 -0.3,0.9 -0.2,0.2 -0.4,0.4 -0.7,0.5 l 1.1,2 h -0.9 l -1,-1.9 h -0.7 v 1.9 z m 0.8,-2.5 h 0.7 c 0.3,0 0.6,-0.1 0.7,-0.2 0.2,-0.1 0.3,-0.3 0.3,-0.6 0,-0.3 -0.1,-0.5 -0.3,-0.6 -0.2,-0.1 -0.4,-0.2 -0.7,-0.2 h -0.7 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7497_"
   d="m 168.1,934.6 v -4.8 h 2.9 v 0.7 h -2 v 1.2 h 1.7 v 0.7 H 169 v 1.4 h 2.1 v 0.7 h -3 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7495_"
   d="m 173.4,934.7 c -0.3,0 -0.6,-0.1 -0.9,-0.2 -0.3,-0.1 -0.6,-0.3 -0.8,-0.5 l 0.5,-0.6 c 0.2,0.2 0.4,0.3 0.6,0.4 0.2,0.1 0.4,0.1 0.7,0.1 0.3,0 0.5,-0.1 0.6,-0.2 0.1,-0.1 0.2,-0.3 0.2,-0.4 0,-0.1 0,-0.2 -0.1,-0.2 -0.1,0 -0.1,-0.1 -0.2,-0.2 -0.1,-0.1 -0.1,-0.1 -0.2,-0.1 -0.1,0 -0.2,-0.1 -0.3,-0.1 l -0.7,-0.3 c -0.1,0 -0.2,-0.1 -0.3,-0.2 -0.1,-0.1 -0.2,-0.2 -0.3,-0.3 -0.1,-0.1 -0.2,-0.2 -0.2,-0.4 -0.1,-0.1 -0.1,-0.3 -0.1,-0.5 0,-0.2 0,-0.4 0.1,-0.5 0.1,-0.1 0.2,-0.3 0.3,-0.4 0.1,-0.1 0.3,-0.2 0.5,-0.3 0.2,-0.1 0.4,-0.1 0.6,-0.1 0.3,0 0.5,0.1 0.8,0.2 0.3,0.1 0.5,0.3 0.7,0.4 l -0.4,0.5 c -0.2,-0.1 -0.3,-0.2 -0.5,-0.3 -0.2,-0.1 -0.3,-0.1 -0.6,-0.1 -0.2,0 -0.4,0 -0.5,0.1 -0.1,0.1 -0.2,0.2 -0.2,0.4 0,0.1 0,0.2 0.1,0.2 0.1,0 0.1,0.1 0.2,0.2 0.1,0.1 0.2,0.1 0.2,0.1 0.1,0 0.2,0.1 0.3,0.1 l 0.6,0.3 c 0.1,0.1 0.3,0.1 0.4,0.2 0.1,0.1 0.2,0.2 0.3,0.3 0.1,0.1 0.2,0.2 0.2,0.4 0,0.2 0.1,0.3 0.1,0.5 0,0.2 0,0.4 -0.1,0.5 -0.1,0.2 -0.2,0.3 -0.3,0.4 -0.1,0.1 -0.3,0.2 -0.5,0.3 -0.3,0.3 -0.5,0.3 -0.8,0.3 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7493_"
   d="m 177.8,934.7 c -0.3,0 -0.5,0 -0.7,-0.1 -0.2,-0.1 -0.4,-0.2 -0.6,-0.4 -0.2,-0.2 -0.3,-0.4 -0.4,-0.7 -0.1,-0.3 -0.1,-0.6 -0.1,-1 v -2.7 h 0.8 v 2.7 c 0,0.3 0,0.5 0.1,0.7 0,0.2 0.1,0.3 0.2,0.4 0.1,0.1 0.2,0.2 0.3,0.2 0.1,0 0.2,0.1 0.4,0.1 0.1,0 0.3,0 0.4,-0.1 0.1,0 0.2,-0.1 0.3,-0.2 0.1,-0.1 0.2,-0.2 0.2,-0.4 0,-0.2 0.1,-0.4 0.1,-0.7 v -2.7 h 0.8 v 2.7 c 0,0.4 0,0.7 -0.1,1 -0.1,0.3 -0.2,0.5 -0.4,0.7 -0.2,0.2 -0.3,0.3 -0.6,0.4 -0.2,0.1 -0.4,0.1 -0.7,0.1 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7491_"
   d="m 180.8,934.6 v -4.8 h 0.8 v 4.1 h 2 v 0.7 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7489_"
   d="m 184.5,934.6 v -4.1 h -1.4 v -0.7 h 3.6 v 0.7 h -1.4 v 4.1 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7486_"
   d="m 186.6,934.6 1.6,-4.8 h 1 l 1.6,4.8 h -0.9 l -0.4,-1.3 h -1.6 l -0.4,1.3 z m 1.6,-2.5 -0.2,0.6 h 1.2 l -0.2,-0.6 c -0.1,-0.3 -0.2,-0.5 -0.2,-0.8 0,-0.3 -0.1,-0.5 -0.2,-0.8 v 0 c -0.1,0.3 -0.1,0.5 -0.2,0.8 0,0.3 -0.1,0.5 -0.2,0.8 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7483_"
   d="m 191.3,934.6 v -4.8 h 1.3 c 0.7,0 1.3,0.2 1.7,0.6 0.4,0.4 0.6,1 0.6,1.8 0,0.4 -0.1,0.7 -0.2,1 -0.1,0.3 -0.3,0.6 -0.5,0.8 -0.2,0.2 -0.4,0.4 -0.7,0.5 -0.3,0.1 -0.6,0.2 -1,0.2 h -1.2 z m 0.9,-0.7 h 0.4 c 0.5,0 0.9,-0.1 1.1,-0.4 0.3,-0.3 0.4,-0.7 0.4,-1.3 0,-0.6 -0.1,-1 -0.4,-1.3 -0.3,-0.3 -0.6,-0.4 -1.1,-0.4 h -0.4 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7480_"
   d="m 197.8,934.7 c -0.3,0 -0.6,-0.1 -0.9,-0.2 -0.3,-0.1 -0.5,-0.3 -0.7,-0.5 -0.2,-0.2 -0.3,-0.5 -0.4,-0.8 -0.1,-0.3 -0.2,-0.7 -0.2,-1 0,-0.4 0.1,-0.7 0.2,-1 0.1,-0.3 0.2,-0.6 0.4,-0.8 0.2,-0.2 0.4,-0.4 0.7,-0.5 0.3,-0.1 0.5,-0.2 0.9,-0.2 0.3,0 0.6,0.1 0.9,0.2 0.3,0.1 0.5,0.3 0.7,0.5 0.2,0.2 0.3,0.5 0.4,0.8 0.1,0.3 0.2,0.6 0.2,1 0,0.4 -0.1,0.7 -0.2,1 -0.1,0.3 -0.2,0.6 -0.4,0.8 -0.2,0.2 -0.4,0.4 -0.7,0.5 -0.3,0.1 -0.6,0.2 -0.9,0.2 z m 0,-0.7 c 0.2,0 0.4,0 0.5,-0.1 0.2,-0.1 0.3,-0.2 0.4,-0.4 0.1,-0.2 0.2,-0.3 0.2,-0.6 0,-0.3 0.1,-0.5 0.1,-0.7 0,-0.5 -0.1,-1 -0.3,-1.3 -0.2,-0.3 -0.5,-0.5 -0.9,-0.5 -0.4,0 -0.7,0.2 -0.9,0.5 -0.2,0.3 -0.3,0.7 -0.3,1.3 0,0.3 0,0.5 0.1,0.7 0.1,0.2 0.1,0.4 0.2,0.6 0.1,0.2 0.2,0.3 0.4,0.4 0.1,0 0.3,0.1 0.5,0.1 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7478_"
   d="m 202.2,934.7 c -0.3,0 -0.6,-0.1 -0.9,-0.2 -0.3,-0.1 -0.6,-0.3 -0.8,-0.5 l 0.5,-0.6 c 0.2,0.2 0.4,0.3 0.6,0.4 0.2,0.1 0.4,0.1 0.7,0.1 0.3,0 0.5,-0.1 0.6,-0.2 0.1,-0.1 0.2,-0.3 0.2,-0.4 0,-0.1 0,-0.2 -0.1,-0.2 0,-0.1 -0.1,-0.1 -0.2,-0.2 -0.1,-0.1 -0.1,-0.1 -0.2,-0.1 -0.1,0 -0.2,-0.1 -0.3,-0.1 l -0.7,-0.3 c -0.1,0 -0.2,-0.1 -0.3,-0.2 -0.1,-0.1 -0.2,-0.2 -0.3,-0.3 -0.1,-0.1 -0.2,-0.2 -0.2,-0.4 -0.1,-0.1 -0.1,-0.3 -0.1,-0.5 0,-0.2 0,-0.4 0.1,-0.5 0.1,-0.1 0.2,-0.3 0.3,-0.4 0.1,-0.1 0.3,-0.2 0.5,-0.3 0.2,-0.1 0.4,-0.1 0.6,-0.1 0.3,0 0.5,0.1 0.8,0.2 0.3,0.1 0.5,0.3 0.7,0.4 l -0.4,0.5 c -0.2,-0.1 -0.3,-0.2 -0.5,-0.3 -0.2,-0.1 -0.3,-0.1 -0.6,-0.1 -0.2,0 -0.4,0 -0.5,0.1 -0.1,0.1 -0.2,0.2 -0.2,0.4 0,0.1 0,0.2 0.1,0.2 0.1,0 0.1,0.1 0.2,0.2 0.1,0.1 0.2,0.1 0.2,0.1 0.1,0 0.2,0.1 0.3,0.1 l 0.6,0.3 c 0.1,0.1 0.3,0.1 0.4,0.2 0.1,0.1 0.2,0.2 0.3,0.3 0.1,0.1 0.2,0.2 0.2,0.4 0,0.2 0.1,0.3 0.1,0.5 0,0.2 0,0.4 -0.1,0.5 -0.1,0.2 -0.2,0.3 -0.3,0.4 -0.1,0.1 -0.3,0.2 -0.5,0.3 -0.3,0.3 -0.5,0.3 -0.8,0.3 z"
   inkscape:connector-curvature="0" />
			</g>
		</g>
	</g>
	<g
   id="XMLID_7443_">
		<circle
   id="XMLID_7448_"
   class="st1015"
   cx="125.6"
   cy="947.79999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_7444_">
			<rect
   id="XMLID_7782_"
   x="118.4"
   y="940.29999"
   class="st739"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(120.4746,954.457)"
   class="st733 st688 st1094"
   id="text708"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">7</text>

		</g>
	</g>
	<g
   id="checkeo6"
   class="oculto"
   inkscape:label="#XMLID_387_">
		
			<linearGradient
   id="XMLID_8337_"
   gradientUnits="userSpaceOnUse"
   x1="240.56149"
   y1="-16778.461"
   x2="240.56149"
   y2="-16747.416"
   gradientTransform="matrix(1,0,0,-1,0,-15815.147)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop712" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop714" />
		</linearGradient>
		<path
   id="XMLID_4368_"
   class="st174"
   d="m 240.6,959.9 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_8337_)" />
		<polygon
   id="XMLID_392_"
   class="st733"
   points="236,947.7 238.4,949.9 245,942.3 247.5,944.4 238.7,954.7 233.7,950.1 "
   style="fill:#ffffff" />
	</g>
</g>
</svg>
</template>
<script>
export default {
  data(){
    return{
      contador:0,
      vistos: Array(8).fill(false)
    } 
  },
    methods:{
    darVisto(num){
      this.$emit('contenido',num)
      this.$set(this.vistos, num, true) 
      let todosVistos = this.vistos.every((el) => {
        return el;
      });
      if(todosVistos){
        this.$store.commit("nextShow", true);
      }
      // this.contador= num+1
      document.getElementById('checkeo'+num).classList.remove('oculto')
      console.log(num+'numero')
    },
  }
}
</script>
<style lang="scss" scoped>
	.st0{fill:#46535B;}
	.st1{fill:none;stroke:url(#XMLID_8843_);stroke-width:3;stroke-miterlimit:10;}
	.st2{fill:#AAAAAA;}
	.st3{fill:#7C9DA5;}
	.st4{fill:#ABBFC6;}
	.st5{fill:#49493A;}
	.st6{fill:#AC7B63;}
	.st7{fill:url(#XMLID_8925_);stroke:#383838;stroke-miterlimit:10;}
	.st8{fill:url(#XMLID_8510_);stroke:#383838;stroke-miterlimit:10;}
	.st9{fill:#ADAC9C;}
	.st10{fill:#ADD86F;}
	.st11{fill:url(#XMLID_8511_);stroke:#383838;stroke-miterlimit:10;}
	.st12{fill:#105477;}
	.st13{fill:none;stroke:url(#XMLID_8353_);stroke-width:6;stroke-miterlimit:10;}
	.st14{fill:#106489;}
	.st15{fill:url(#XMLID_8929_);stroke:#383838;stroke-miterlimit:10;}
	.st16{fill:none;stroke:url(#XMLID_8469_);stroke-width:4;stroke-miterlimit:10;}
	.st17{fill:none;stroke:url(#XMLID_8354_);stroke-width:6;stroke-miterlimit:10;}
	.st18{fill:none;stroke:url(#XMLID_8914_);stroke-width:4;stroke-miterlimit:10;}
	.st19{fill:none;stroke:url(#XMLID_8782_);stroke-width:2;stroke-miterlimit:10;}
	.st20{fill:#AED379;}
	.st21{fill:none;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st22{fill:url(#XMLID_9138_);stroke:#383838;stroke-miterlimit:10;}
	.st23{fill:#E0B192;}
	.st24{fill:#E0CEBD;}
	.st25{fill:#E0D6D1;}
	.st26{fill:#E0E2DE;}
	.st27{fill:#FFFFFF;stroke:url(#XMLID_8700_);stroke-width:0.25;stroke-miterlimit:10;}
	.st28{fill:#FFFFFF;stroke:url(#XMLID_8682_);stroke-width:0.25;stroke-miterlimit:10;}
	.st29{fill:#132C33;}
	.st30{fill:#FFFFFF;stroke:url(#XMLID_8939_);stroke-width:3;stroke-miterlimit:10;}
	.st31{fill:#E1E1E1;}
	.st32{fill:#E24471;}
	.st33{fill:#FFFFFF;stroke:url(#XMLID_9146_);stroke-width:3;stroke-miterlimit:10;}
	.st34{fill:#144191;}
	.st35{fill:#E2E2E2;}
	.st36{fill:none;stroke:#FF7676;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}
	.st37{fill:none;stroke:url(#XMLID_8151_);stroke-width:6;stroke-miterlimit:10;}
	.st38{fill:#FFFFFF;stroke:url(#XMLID_8692_);stroke-width:0.25;stroke-miterlimit:10;}
	.st39{fill:none;stroke:url(#XMLID_8855_);stroke-width:3;stroke-miterlimit:10;}
	.st40{fill:url(#XMLID_7822_);}
	.st41{fill:url(#XMLID_7823_);}
	.st42{fill:url(#XMLID_7829_);}
	.st43{fill:url(#XMLID_8481_);stroke:#383838;stroke-miterlimit:10;}
	.st44{fill:none;stroke:#042AB2;stroke-width:5;stroke-miterlimit:10;}
	.st45{fill:#FFFFFF;stroke:url(#XMLID_8704_);stroke-width:0.25;stroke-miterlimit:10;}
	.st46{fill:#FFFFFF;stroke:url(#XMLID_8686_);stroke-width:0.25;stroke-miterlimit:10;}
	.st47{fill:url(#XMLID_8930_);stroke:#383838;stroke-miterlimit:10;}
	.st48{fill:none;stroke:#1D1D1B;stroke-width:0.5;stroke-miterlimit:10;}
	.st49{clip-path:url(#XMLID_429_);}
	.st50{fill:#4A7B8E;}
	.st51{fill:#E50A0A;}
	.st52{fill:#E51B72;}
	.st53{fill:none;stroke:url(#XMLID_8471_);stroke-width:4;stroke-miterlimit:10;}
	.st54{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st55{fill:none;stroke:url(#XMLID_8419_);stroke-width:2;stroke-miterlimit:10;}
	.st56{fill:#E5E1DC;}
	.st57{fill:none;stroke:url(#XMLID_8360_);stroke-width:6;stroke-miterlimit:10;}
	.st58{fill:url(#XMLID_9142_);stroke:#383838;stroke-miterlimit:10;}
	.st59{fill:url(#XMLID_9143_);stroke:#383838;stroke-miterlimit:10;}
	.st60{fill:#191A1C;}
	.st61{fill:none;stroke:#F9385D;stroke-width:3;stroke-miterlimit:10;}
	.st62{opacity:0.39;fill:#042AB2;}
	.st63{fill:#FFFFFF;stroke:url(#XMLID_8941_);stroke-width:3;stroke-miterlimit:10;}
	.st64{fill:#4D8E02;}
	.st65{fill:#FFFFFF;stroke:url(#XMLID_8708_);stroke-width:0.25;stroke-miterlimit:10;}
	.st66{fill:#E866FF;}
	.st67{fill:#E8B897;}
	.st68{fill:#E8E8DA;}
	.st69{fill:#E8E8E8;}
	.st70{fill:#FFFFFF;stroke:url(#XMLID_8945_);stroke-width:3;stroke-miterlimit:10;}
	.st71{fill:#FFFFFF;stroke:url(#XMLID_9151_);stroke-width:3;stroke-miterlimit:10;}
	.st72{fill:none;stroke:url(#XMLID_8658_);stroke-width:3;stroke-miterlimit:10;}
	.st73{fill:none;stroke:url(#XMLID_8824_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st74{fill:#FFFFFF;stroke:url(#XMLID_8948_);stroke-width:3;stroke-miterlimit:10;}
	.st75{fill:#4F4D4F;}
	.st76{fill:#4F514C;}
	.st77{fill:none;stroke:url(#XMLID_8405_);stroke-width:6;stroke-miterlimit:10;}
	.st78{fill:none;stroke:#96BCB5;stroke-miterlimit:10;}
	.st79{fill:none;stroke:url(#XMLID_8406_);stroke-width:6;stroke-miterlimit:10;}
	.st80{fill:#FFFFFF;stroke:url(#XMLID_9159_);stroke-width:3;stroke-miterlimit:10;}
	.st81{fill:#B0CAD1;}
	.st82{fill:#B0D882;}
	.st83{fill:#B0FFFF;}
	.st84{fill:none;stroke:url(#XMLID_8865_);stroke-width:3;stroke-miterlimit:10;}
	.st85{fill:url(#XMLID_8491_);stroke:#383838;stroke-miterlimit:10;}
	.st86{fill:url(#XMLID_8493_);stroke:#383838;stroke-miterlimit:10;}
	.st87{fill:none;stroke:#E2E2E2;stroke-miterlimit:10;}
	.st88{fill:#83FFE7;}
	.st89{fill:#FFFFFF;stroke:#444444;stroke-miterlimit:10;}
	.st90{fill:#848484;}
	.st91{fill:#B4754D;}
	.st92{fill:#B4B4B4;}
	.st93{fill:none;stroke:url(#XMLID_8660_);stroke-width:3;stroke-miterlimit:10;}
	.st94{fill:none;stroke:#1E1E1E;stroke-miterlimit:10;}
	.st95{fill:#B5AC9C;}
	.st96{fill:#B5B5B5;}
	.st97{fill:none;stroke:url(#XMLID_455_);stroke-width:2;stroke-miterlimit:10;}
	.st98{fill:#EAEAEA;}
	.st99{fill:#FFFFFF;stroke:url(#XMLID_9164_);stroke-width:3;stroke-miterlimit:10;}
	.st100{fill:#B7B7B7;}
	.st101{fill:#1D1D1B;}
	.st102{fill:#898989;}
	.st103{fill:none;stroke:url(#XMLID_8542_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st104{fill:#1E1E1E;}
	.st105{fill:url(#XMLID_8769_);stroke:#232323;stroke-miterlimit:10;}
	.st106{fill:#EDEDED;}
	.st107{fill:#505154;}
	.st108{fill:#FFFFFF;stroke:url(#XMLID_9205_);stroke-width:3;stroke-miterlimit:10;}
	.st109{fill:#513B1E;}
	.st110{fill:#515151;}
	.st111{fill:#EF5A24;}
	.st112{fill:#FFFFFF;stroke:url(#XMLID_9208_);stroke-width:3;stroke-miterlimit:10;}
	.st113{fill:none;stroke:url(#XMLID_9034_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st114{fill:#EFEFEF;}
	.st115{fill:url(#XMLID_9182_);stroke:#232323;stroke-miterlimit:10;}
	.st116{fill:none;stroke:url(#XMLID_8497_);stroke-width:4;stroke-miterlimit:10;}
	.st117{fill:none;stroke:url(#XMLID_8383_);stroke-width:6;stroke-miterlimit:10;}
	.st118{fill:none;stroke:url(#XMLID_9124_);stroke-width:3;stroke-miterlimit:10;}
	.st119{fill:none;stroke:url(#XMLID_8389_);stroke-width:6;stroke-miterlimit:10;}
	.st120{fill:#544733;}
	.st121{fill:#545454;}
	.st122{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
	.st123{fill:none;stroke:url(#XMLID_8649_);stroke-width:2;stroke-miterlimit:10;}
	.st124{fill:none;stroke:url(#XMLID_9082_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st125{fill:#555555;}
	.st126{fill:#FFFFFF;stroke:url(#XMLID_9003_);stroke-width:3;stroke-miterlimit:10;}
	.st127{fill:none;stroke:url(#XMLID_8422_);stroke-width:6;stroke-miterlimit:10;}
	.st128{fill:#FFFFFF;stroke:url(#XMLID_9005_);stroke-width:3;stroke-miterlimit:10;}
	.st129{fill:#FFFFFF;stroke:url(#XMLID_9174_);stroke-width:3;stroke-miterlimit:10;}
	.st130{fill:#56361A;}
	.st131{fill:#564A3D;}
	.st132{fill:none;stroke:url(#XMLID_9048_);stroke-width:6;stroke-miterlimit:10;}
	.st133{fill:#FFFFFF;stroke:url(#XMLID_9009_);stroke-width:3;stroke-miterlimit:10;}
	.st134{fill:#FFFFFF;stroke:url(#XMLID_8681_);stroke-width:0.25;stroke-miterlimit:10;}
	.st135{fill:none;stroke:url(#XMLID_9049_);stroke-width:6;stroke-miterlimit:10;}
	.st136{fill:none;stroke:url(#XMLID_8883_);stroke-width:3;stroke-miterlimit:10;}
	.st137{fill:#BAC8D1;}
	.st138{fill:#BB8062;}
	.st139{fill:none;stroke:url(#XMLID_8968_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st140{fill:none;stroke:#28F7D1;stroke-width:3;stroke-miterlimit:10;}
	.st141{fill:none;stroke:url(#XMLID_8888_);stroke-width:3;stroke-miterlimit:10;}
	.st142{fill:none;stroke:url(#XMLID_7825_);stroke-width:2;stroke-miterlimit:10;}
	.st143{fill:#FFFFFF;stroke:url(#XMLID_9214_);stroke-width:3;stroke-miterlimit:10;}
	.st144{fill:url(#XMLID_8108_);}
	.st145{fill:url(#XMLID_8110_);}
	.st146{fill:url(#XMLID_8116_);}
	.st147{fill:url(#XMLID_8123_);}
	.st148{fill:url(#XMLID_8124_);}
	.st149{fill:url(#XMLID_8136_);}
	.st150{fill:url(#XMLID_8138_);}
	.st151{fill:url(#XMLID_8150_);}
	.st152{fill:url(#XMLID_8153_);}
	.st153{fill:url(#XMLID_8158_);}
	.st154{fill:url(#XMLID_8236_);}
	.st155{fill:url(#XMLID_8241_);}
	.st156{fill:#FFFFFF;stroke:url(#XMLID_8703_);stroke-width:0.25;stroke-miterlimit:10;}
	.st157{fill:#FFFFFF;stroke:url(#XMLID_8685_);stroke-width:0.25;stroke-miterlimit:10;}
	.st158{fill:#8E734F;}
	.st159{fill:none;stroke:url(#XMLID_8650_);stroke-width:2;stroke-miterlimit:10;}
	.st160{opacity:0.37;fill:url(#XMLID_8412_);}
	.st161{opacity:0.37;fill:url(#XMLID_8414_);}
	.st162{opacity:0.37;fill:url(#XMLID_8415_);}
	.st163{fill:none;stroke:url(#XMLID_8651_);stroke-width:2;stroke-miterlimit:10;}
	.st164{fill:none;stroke:#F9385D;stroke-width:2;stroke-miterlimit:10;}
	.st165{fill:url(#XMLID_8320_);}
	.st166{fill:url(#XMLID_8322_);}
	.st167{fill:url(#XMLID_8323_);}
	.st168{fill:url(#XMLID_8325_);}
	.st169{fill:url(#XMLID_8326_);}
	.st170{fill:url(#XMLID_8329_);}
	.st171{fill:url(#XMLID_8330_);}
	.st172{fill:url(#XMLID_8333_);}
	.st173{fill:url(#XMLID_8334_);}
	.st174{fill:url(#XMLID_8337_);}
	.st175{fill:url(#XMLID_8338_);}
	.st176{fill:url(#XMLID_8340_);}
	.st177{fill:url(#XMLID_8341_);}
	.st178{fill:url(#XMLID_8343_);}
	.st179{fill:url(#XMLID_8345_);}
	.st180{fill:url(#XMLID_8349_);}
	.st181{fill:url(#XMLID_8356_);}
	.st182{fill:url(#XMLID_8357_);}
	.st183{fill:none;stroke:url(#XMLID_8652_);stroke-width:2;stroke-miterlimit:10;}
	.st184{fill:url(#XMLID_8361_);}
	.st185{fill:url(#XMLID_8363_);}
	.st186{fill:url(#XMLID_8364_);}
	.st187{fill:url(#XMLID_8367_);}
	.st188{fill:url(#XMLID_8368_);}
	.st189{fill:url(#XMLID_8370_);}
	.st190{fill:url(#XMLID_8371_);}
	.st191{fill:url(#XMLID_8373_);}
	.st192{fill:url(#XMLID_8374_);}
	.st193{fill:url(#XMLID_8376_);}
	.st194{fill:url(#XMLID_8377_);}
	.st195{fill:url(#XMLID_8379_);}
	.st196{fill:url(#XMLID_8380_);}
	.st197{fill:url(#XMLID_8382_);}
	.st198{fill:url(#XMLID_8386_);}
	.st199{fill:url(#XMLID_8387_);}
	.st200{fill:url(#XMLID_8390_);}
	.st201{fill:url(#XMLID_8392_);}
	.st202{fill:url(#XMLID_8393_);}
	.st203{fill:url(#XMLID_8394_);}
	.st204{fill:#C7EE95;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st205{fill:none;stroke:url(#XMLID_8653_);stroke-width:2;stroke-miterlimit:10;}
	.st206{fill:#8F9D9E;}
	.st207{fill:none;stroke:url(#XMLID_8654_);stroke-width:2;stroke-miterlimit:10;}
	.st208{fill:#FFFFFF;stroke:url(#XMLID_8971_);stroke-width:3;stroke-miterlimit:10;}
	.st209{fill:url(#XMLID_8402_);}
	.st210{fill:url(#XMLID_8408_);}
	.st211{fill:url(#XMLID_8409_);}
	.st212{fill:url(#XMLID_8411_);}
	.st213{fill:url(#XMLID_8424_);}
	.st214{fill:url(#XMLID_8425_);}
	.st215{fill:url(#XMLID_8427_);}
	.st216{fill:url(#XMLID_8428_);}
	.st217{fill:url(#XMLID_8430_);}
	.st218{fill:url(#XMLID_8431_);}
	.st219{fill:url(#XMLID_8434_);}
	.st220{fill:url(#XMLID_8435_);}
	.st221{fill:url(#XMLID_8437_);}
	.st222{fill:url(#XMLID_8438_);}
	.st223{fill:url(#XMLID_8440_);}
	.st224{fill:url(#XMLID_8441_);}
	.st225{fill:url(#XMLID_8443_);}
	.st226{fill:url(#XMLID_8444_);}
	.st227{fill:url(#XMLID_8446_);}
	.st228{fill:url(#XMLID_8447_);}
	.st229{fill:url(#XMLID_8449_);}
	.st230{fill:url(#XMLID_8450_);}
	.st231{fill:url(#XMLID_8452_);}
	.st232{fill:url(#XMLID_8453_);}
	.st233{fill:url(#XMLID_8456_);}
	.st234{fill:url(#XMLID_8458_);}
	.st235{fill:url(#XMLID_8459_);}
	.st236{fill:url(#XMLID_8461_);}
	.st237{fill:url(#XMLID_8462_);}
	.st238{fill:url(#XMLID_8465_);}
	.st239{fill:url(#XMLID_8466_);}
	.st240{fill:url(#XMLID_8472_);}
	.st241{fill:#FFFFFF;stroke:url(#XMLID_8972_);stroke-width:3;stroke-miterlimit:10;}
	.st242{fill:url(#XMLID_8473_);}
	.st243{fill:url(#XMLID_8476_);}
	.st244{fill:url(#XMLID_8477_);}
	.st245{fill:url(#XMLID_8480_);}
	.st246{fill:url(#XMLID_8484_);}
	.st247{fill:url(#XMLID_8490_);}
	.st248{fill:url(#XMLID_8494_);}
	.st249{fill:url(#XMLID_8499_);}
	.st250{fill:#BFBFBF;}
	.st251{fill:#FFFFFF;stroke:url(#XMLID_8713_);stroke-width:0.25;stroke-miterlimit:10;}
	.st252{fill:url(#XMLID_8501_);}
	.st253{fill:url(#XMLID_8502_);}
	.st254{fill:url(#XMLID_8503_);}
	.st255{fill:url(#XMLID_8504_);}
	.st256{fill:url(#XMLID_8505_);}
	.st257{fill:url(#XMLID_8508_);}
	.st258{fill:url(#XMLID_8509_);}
	.st259{fill:url(#XMLID_8512_);}
	.st260{fill:url(#XMLID_8513_);}
	.st261{fill:url(#XMLID_8514_);}
	.st262{fill:url(#XMLID_8515_);}
	.st263{fill:url(#XMLID_8516_);}
	.st264{fill:url(#XMLID_8517_);}
	.st265{fill:url(#XMLID_8518_);}
	.st266{fill:url(#XMLID_8521_);}
	.st267{fill:url(#XMLID_8522_);}
	.st268{fill:url(#XMLID_8523_);}
	.st269{fill:url(#XMLID_8524_);}
	.st270{fill:url(#XMLID_8525_);}
	.st271{fill:url(#XMLID_8526_);}
	.st272{fill:url(#XMLID_8527_);}
	.st273{fill:url(#XMLID_8528_);}
	.st274{fill:url(#XMLID_8529_);}
	.st275{fill:url(#XMLID_8530_);}
	.st276{fill:url(#XMLID_8531_);}
	.st277{fill:url(#XMLID_8532_);}
	.st278{fill:url(#XMLID_8533_);}
	.st279{fill:url(#XMLID_8534_);}
	.st280{fill:url(#XMLID_8535_);}
	.st281{fill:url(#XMLID_8536_);}
	.st282{fill:url(#XMLID_8537_);}
	.st283{fill:url(#XMLID_8538_);}
	.st284{fill:url(#XMLID_8539_);}
	.st285{fill:url(#XMLID_8544_);}
	.st286{fill:url(#XMLID_8545_);}
	.st287{fill:url(#XMLID_8547_);}
	.st288{fill:url(#XMLID_8548_);}
	.st289{fill:url(#XMLID_8549_);}
	.st290{fill:url(#XMLID_8550_);}
	.st291{fill:url(#XMLID_8551_);}
	.st292{fill:url(#XMLID_8552_);}
	.st293{fill:url(#XMLID_8553_);}
	.st294{fill:url(#XMLID_8554_);}
	.st295{fill:url(#XMLID_8555_);}
	.st296{fill:url(#XMLID_8556_);}
	.st297{fill:url(#XMLID_8557_);}
	.st298{fill:url(#XMLID_8558_);}
	.st299{fill:url(#XMLID_8559_);}
	.st300{fill:url(#XMLID_8560_);}
	.st301{fill:url(#XMLID_8561_);}
	.st302{fill:url(#XMLID_8562_);}
	.st303{fill:url(#XMLID_8563_);}
	.st304{fill:url(#XMLID_8564_);}
	.st305{fill:url(#XMLID_8565_);}
	.st306{fill:url(#XMLID_8566_);}
	.st307{fill:url(#XMLID_8567_);}
	.st308{fill:url(#XMLID_8568_);}
	.st309{fill:url(#XMLID_8569_);}
	.st310{fill:url(#XMLID_8570_);}
	.st311{fill:url(#XMLID_8571_);}
	.st312{fill:url(#XMLID_8572_);}
	.st313{fill:url(#XMLID_8573_);}
	.st314{fill:url(#XMLID_8574_);}
	.st315{fill:url(#XMLID_8575_);}
	.st316{fill:url(#XMLID_8576_);}
	.st317{fill:url(#XMLID_8577_);}
	.st318{fill:url(#XMLID_8578_);}
	.st319{fill:url(#XMLID_8579_);}
	.st320{fill:url(#XMLID_8580_);}
	.st321{fill:url(#XMLID_8581_);}
	.st322{fill:url(#XMLID_8582_);}
	.st323{fill:url(#XMLID_8583_);}
	.st324{fill:url(#XMLID_8584_);}
	.st325{fill:url(#XMLID_8585_);}
	.st326{fill:url(#XMLID_8586_);}
	.st327{fill:url(#XMLID_8587_);}
	.st328{fill:url(#XMLID_8588_);}
	.st329{fill:url(#XMLID_8589_);}
	.st330{fill:url(#XMLID_8590_);}
	.st331{fill:url(#XMLID_8591_);}
	.st332{fill:url(#XMLID_8592_);}
	.st333{fill:url(#XMLID_8593_);}
	.st334{fill:url(#XMLID_8594_);}
	.st335{fill:url(#XMLID_8595_);}
	.st336{fill:url(#XMLID_8596_);}
	.st337{fill:url(#XMLID_8597_);}
	.st338{fill:url(#XMLID_8598_);}
	.st339{fill:url(#XMLID_8599_);}
	.st340{fill:#FFFFFF;stroke:url(#XMLID_9012_);stroke-width:3;stroke-miterlimit:10;}
	.st341{fill:none;stroke:url(#XMLID_8519_);stroke-width:3;stroke-miterlimit:10;}
	.st342{fill:none;stroke:url(#XMLID_9052_);stroke-width:6;stroke-miterlimit:10;}
	.st343{opacity:0.58;fill:#FFFFFF;}
	.st344{fill:#FFFFFF;stroke:url(#XMLID_8979_);stroke-width:3;stroke-miterlimit:10;}
	.st345{fill:url(#XMLID_8600_);}
	.st346{fill:url(#XMLID_8601_);}
	.st347{fill:url(#XMLID_8602_);}
	.st348{fill:none;stroke:url(#XMLID_9054_);stroke-width:6;stroke-miterlimit:10;}
	.st349{fill:url(#XMLID_8603_);}
	.st350{fill:url(#XMLID_8604_);}
	.st351{fill:url(#XMLID_8605_);}
	.st352{fill:url(#XMLID_8606_);}
	.st353{fill:url(#XMLID_8607_);}
	.st354{fill:url(#XMLID_8608_);}
	.st355{fill:url(#XMLID_8609_);}
	.st356{fill:url(#XMLID_8610_);}
	.st357{fill:url(#XMLID_8611_);}
	.st358{fill:url(#XMLID_8612_);}
	.st359{fill:url(#XMLID_8613_);}
	.st360{fill:url(#XMLID_8614_);}
	.st361{fill:url(#XMLID_8615_);}
	.st362{fill:url(#XMLID_8616_);}
	.st363{fill:url(#XMLID_8617_);}
	.st364{fill:url(#XMLID_8618_);}
	.st365{fill:url(#XMLID_8619_);}
	.st366{fill:#2368D9;}
	.st367{fill:url(#XMLID_8620_);}
	.st368{fill:url(#XMLID_8621_);}
	.st369{fill:url(#XMLID_8622_);}
	.st370{fill:url(#XMLID_8623_);}
	.st371{fill:url(#XMLID_8624_);}
	.st372{fill:url(#XMLID_8625_);}
	.st373{fill:url(#XMLID_8626_);}
	.st374{fill:url(#XMLID_8627_);}
	.st375{fill:url(#XMLID_8628_);}
	.st376{fill:url(#XMLID_8629_);}
	.st377{fill:#FFFFFF;stroke:url(#XMLID_8707_);stroke-width:0.25;stroke-miterlimit:10;}
	.st378{fill:url(#XMLID_8630_);}
	.st379{fill:url(#XMLID_8631_);}
	.st380{fill:url(#XMLID_8632_);}
	.st381{fill:url(#XMLID_8633_);}
	.st382{fill:url(#XMLID_8634_);}
	.st383{fill:url(#XMLID_8635_);}
	.st384{fill:url(#XMLID_8636_);}
	.st385{fill:url(#XMLID_8637_);}
	.st386{fill:url(#XMLID_8640_);}
	.st387{fill:url(#XMLID_8641_);}
	.st388{fill:#FFFFFF;stroke:url(#XMLID_8689_);stroke-width:0.25;stroke-miterlimit:10;}
	.st389{fill:url(#XMLID_8644_);}
	.st390{fill:url(#XMLID_8645_);}
	.st391{fill:url(#XMLID_8646_);}
	.st392{fill:url(#XMLID_8647_);}
	.st393{fill:url(#XMLID_8648_);}
	.st394{fill:url(#XMLID_8656_);}
	.st395{fill:url(#XMLID_8657_);}
	.st396{fill:url(#XMLID_8662_);}
	.st397{fill:url(#XMLID_8663_);}
	.st398{fill:url(#XMLID_8664_);}
	.st399{fill:url(#XMLID_8665_);}
	.st400{fill:url(#XMLID_8666_);}
	.st401{fill:url(#XMLID_8667_);}
	.st402{fill:url(#XMLID_8668_);}
	.st403{fill:url(#XMLID_8669_);}
	.st404{fill:url(#XMLID_8670_);}
	.st405{fill:url(#XMLID_8671_);}
	.st406{fill:url(#XMLID_8672_);}
	.st407{fill:url(#XMLID_8673_);}
	.st408{fill:url(#XMLID_8674_);}
	.st409{fill:url(#XMLID_8675_);}
	.st410{fill:url(#XMLID_8676_);}
	.st411{fill:url(#XMLID_8677_);}
	.st412{fill:url(#XMLID_8678_);}
	.st413{fill:url(#XMLID_8679_);}
	.st414{fill:url(#XMLID_8690_);}
	.st415{fill:url(#XMLID_8691_);}
	.st416{fill:url(#XMLID_8695_);}
	.st417{fill:url(#XMLID_8696_);}
	.st418{fill:url(#XMLID_8697_);}
	.st419{fill:url(#XMLID_8698_);}
	.st420{fill:#23CAD9;}
	.st421{fill:url(#XMLID_8709_);}
	.st422{fill:none;stroke:url(#XMLID_8891_);stroke-width:3;stroke-miterlimit:10;}
	.st423{fill:url(#XMLID_8710_);}
	.st424{fill:url(#XMLID_8714_);}
	.st425{fill:url(#XMLID_8715_);}
	.st426{fill:url(#XMLID_8716_);}
	.st427{fill:#F2F2F2;}
	.st428{fill:url(#XMLID_8722_);}
	.st429{fill:url(#XMLID_8723_);}
	.st430{fill:url(#XMLID_8724_);}
	.st431{fill:url(#XMLID_8730_);}
	.st432{fill:url(#XMLID_8735_);}
	.st433{fill:url(#XMLID_8736_);}
	.st434{fill:url(#XMLID_8742_);}
	.st435{fill:url(#XMLID_8743_);}
	.st436{fill:url(#XMLID_8744_);}
	.st437{fill:url(#XMLID_8750_);}
	.st438{fill:url(#XMLID_8752_);}
	.st439{fill:url(#XMLID_8753_);}
	.st440{fill:url(#XMLID_8756_);}
	.st441{fill:url(#XMLID_8758_);}
	.st442{fill:url(#XMLID_8762_);}
	.st443{fill:url(#XMLID_8763_);}
	.st444{fill:url(#XMLID_8764_);}
	.st445{fill:url(#XMLID_8765_);}
	.st446{clip-path:url(#XMLID_7789_);}
	.st447{fill:url(#XMLID_8766_);}
	.st448{fill:url(#XMLID_8767_);}
	.st449{fill:url(#XMLID_8770_);}
	.st450{fill:url(#XMLID_8771_);}
	.st451{fill:url(#XMLID_8774_);}
	.st452{fill:url(#XMLID_8775_);}
	.st453{fill:url(#XMLID_8776_);}
	.st454{fill:url(#XMLID_8777_);}
	.st455{fill:url(#XMLID_8778_);}
	.st456{fill:url(#XMLID_8779_);}
	.st457{fill:url(#XMLID_8780_);}
	.st458{fill:url(#XMLID_8781_);}
	.st459{fill:url(#XMLID_8783_);}
	.st460{fill:url(#XMLID_8785_);}
	.st461{fill:url(#XMLID_8786_);}
	.st462{fill:url(#XMLID_8787_);}
	.st463{fill:url(#XMLID_8790_);}
	.st464{fill:url(#XMLID_8791_);}
	.st465{fill:url(#XMLID_8792_);}
	.st466{fill:url(#XMLID_8793_);}
	.st467{fill:url(#XMLID_8794_);}
	.st468{fill:url(#XMLID_8795_);}
	.st469{fill:url(#XMLID_8796_);}
	.st470{fill:url(#XMLID_8797_);}
	.st471{fill:url(#XMLID_8798_);}
	.st472{fill:none;stroke:url(#XMLID_8894_);stroke-width:3;stroke-miterlimit:10;}
	.st473{fill:url(#XMLID_8768_);stroke:#383838;stroke-miterlimit:10;}
	.st474{fill:url(#XMLID_8801_);}
	.st475{fill:url(#XMLID_8802_);}
	.st476{clip-path:url(#XMLID_7826_);}
	.st477{fill:url(#XMLID_8805_);}
	.st478{fill:url(#XMLID_8806_);}
	.st479{fill:url(#XMLID_8807_);}
	.st480{fill:url(#XMLID_8808_);}
	.st481{fill:url(#XMLID_8809_);}
	.st482{fill:url(#XMLID_8810_);}
	.st483{fill:url(#XMLID_8811_);}
	.st484{fill:url(#XMLID_8812_);}
	.st485{fill:url(#XMLID_8813_);}
	.st486{fill:url(#XMLID_8814_);}
	.st487{fill:url(#XMLID_8815_);}
	.st488{fill:url(#XMLID_8816_);}
	.st489{fill:url(#XMLID_8817_);}
	.st490{fill:url(#XMLID_8818_);}
	.st491{fill:url(#XMLID_8819_);}
	.st492{fill:#F3F3E5;}
	.st493{fill:url(#XMLID_8820_);}
	.st494{fill:url(#XMLID_8821_);}
	.st495{fill:url(#XMLID_8822_);}
	.st496{fill:url(#XMLID_8823_);}
	.st497{fill:url(#XMLID_8828_);}
	.st498{fill:url(#XMLID_8831_);}
	.st499{fill:url(#XMLID_8832_);}
	.st500{fill:url(#XMLID_8833_);}
	.st501{fill:url(#XMLID_8834_);}
	.st502{fill:url(#XMLID_8835_);}
	.st503{fill:url(#XMLID_8838_);}
	.st504{fill:url(#XMLID_8839_);}
	.st505{fill:url(#XMLID_8842_);}
	.st506{fill:url(#XMLID_8844_);}
	.st507{fill:url(#XMLID_8845_);}
	.st508{fill:url(#XMLID_8846_);}
	.st509{fill:url(#XMLID_8847_);}
	.st510{fill:url(#XMLID_8848_);}
	.st511{fill:url(#XMLID_8849_);}
	.st512{fill:url(#XMLID_8850_);}
	.st513{fill:url(#XMLID_8851_);}
	.st514{fill:url(#XMLID_8852_);}
	.st515{fill:url(#XMLID_8854_);}
	.st516{fill:url(#XMLID_8856_);}
	.st517{fill:url(#XMLID_8857_);}
	.st518{fill:url(#XMLID_8858_);}
	.st519{fill:url(#XMLID_8859_);}
	.st520{fill:url(#XMLID_8860_);}
	.st521{fill:url(#XMLID_8861_);}
	.st522{fill:url(#XMLID_8862_);}
	.st523{fill:url(#XMLID_8864_);}
	.st524{fill:url(#XMLID_8866_);}
	.st525{fill:url(#XMLID_8867_);}
	.st526{fill:url(#XMLID_8868_);}
	.st527{fill:url(#XMLID_8869_);}
	.st528{fill:url(#XMLID_8870_);}
	.st529{fill:url(#XMLID_8871_);}
	.st530{fill:url(#XMLID_8872_);}
	.st531{fill:url(#XMLID_8717_);stroke:#444444;stroke-miterlimit:10;}
	.st532{fill:url(#XMLID_8873_);}
	.st533{fill:url(#XMLID_8874_);}
	.st534{fill:url(#XMLID_8875_);}
	.st535{fill:url(#XMLID_8876_);}
	.st536{fill:url(#XMLID_8877_);}
	.st537{fill:url(#XMLID_8878_);}
	.st538{fill:url(#XMLID_8879_);}
	.st539{fill:url(#XMLID_8880_);}
	.st540{fill:url(#XMLID_8881_);}
	.st541{fill:url(#XMLID_8882_);}
	.st542{fill:url(#XMLID_8885_);}
	.st543{fill:url(#XMLID_8886_);}
	.st544{fill:url(#XMLID_8887_);}
	.st545{fill:url(#XMLID_8889_);}
	.st546{fill:none;stroke:url(#XMLID_8896_);stroke-width:3;stroke-miterlimit:10;}
	.st547{fill:url(#XMLID_8890_);}
	.st548{fill:url(#XMLID_8892_);}
	.st549{fill:url(#XMLID_8893_);}
	.st550{fill:url(#XMLID_8897_);}
	.st551{fill:url(#XMLID_8898_);}
	.st552{fill:url(#XMLID_8899_);}
	.st553{fill:#FFFFFF;stroke:url(#XMLID_8699_);stroke-width:0.25;stroke-miterlimit:10;}
	.st554{fill:url(#XMLID_8718_);stroke:#444444;stroke-miterlimit:10;}
	.st555{fill:url(#XMLID_8990_);stroke:#232323;stroke-miterlimit:10;}
	.st556{fill:url(#XMLID_8719_);stroke:#444444;stroke-miterlimit:10;}
	.st557{fill:#FFFFFF;stroke:url(#XMLID_9223_);stroke-width:3;stroke-miterlimit:10;}
	.st558{fill:#F4C4A4;}
	.st559{fill:none;stroke:url(#XMLID_8757_);stroke-width:4;stroke-miterlimit:10;}
	.st560{fill:url(#XMLID_8900_);}
	.st561{fill:url(#XMLID_8902_);}
	.st562{fill:url(#XMLID_8903_);}
	.st563{fill:url(#XMLID_8904_);}
	.st564{fill:url(#XMLID_8905_);}
	.st565{fill:url(#XMLID_8906_);}
	.st566{fill:url(#XMLID_8907_);}
	.st567{fill:url(#XMLID_8908_);}
	.st568{fill:url(#XMLID_8909_);}
	.st569{fill:url(#XMLID_8910_);}
	.st570{fill:url(#XMLID_8911_);}
	.st571{fill:url(#XMLID_8912_);}
	.st572{fill:url(#XMLID_8913_);}
	.st573{fill:url(#XMLID_8916_);}
	.st574{fill:url(#XMLID_8917_);}
	.st575{fill:none;stroke:url(#XMLID_8314_);stroke-width:3;stroke-miterlimit:10;}
	.st576{fill:url(#XMLID_8920_);}
	.st577{fill:url(#XMLID_8921_);}
	.st578{fill:url(#XMLID_8922_);}
	.st579{fill:url(#XMLID_8923_);}
	.st580{fill:url(#XMLID_8924_);}
	.st581{fill:url(#XMLID_8927_);}
	.st582{fill:url(#XMLID_8928_);}
	.st583{fill:url(#XMLID_8931_);}
	.st584{fill:url(#XMLID_8932_);}
	.st585{fill:url(#XMLID_8933_);}
	.st586{fill:url(#XMLID_8934_);}
	.st587{fill:url(#XMLID_8935_);}
	.st588{fill:url(#XMLID_8936_);}
	.st589{fill:url(#XMLID_8937_);}
	.st590{fill:url(#XMLID_8940_);}
	.st591{fill:url(#XMLID_8942_);}
	.st592{fill:url(#XMLID_8943_);}
	.st593{fill:url(#XMLID_8944_);}
	.st594{fill:url(#XMLID_8946_);}
	.st595{fill:url(#XMLID_8947_);}
	.st596{fill:url(#XMLID_8949_);}
	.st597{fill:url(#XMLID_8950_);}
	.st598{fill:url(#XMLID_8951_);}
	.st599{fill:url(#XMLID_8952_);}
	.st600{fill:url(#XMLID_8953_);}
	.st601{fill:url(#XMLID_8954_);}
	.st602{fill:url(#XMLID_8955_);}
	.st603{fill:url(#XMLID_8956_);}
	.st604{fill:url(#XMLID_8957_);}
	.st605{fill:url(#XMLID_8958_);}
	.st606{fill:url(#XMLID_8959_);}
	.st607{fill:url(#XMLID_8960_);}
	.st608{fill:url(#XMLID_8961_);}
	.st609{fill:url(#XMLID_8962_);}
	.st610{fill:url(#XMLID_8963_);}
	.st611{fill:url(#XMLID_8964_);}
	.st612{fill:url(#XMLID_8965_);}
	.st613{fill:url(#XMLID_8966_);}
	.st614{fill:url(#XMLID_8967_);}
	.st615{fill:url(#XMLID_8974_);}
	.st616{fill:url(#XMLID_8975_);}
	.st617{fill:url(#XMLID_8976_);}
	.st618{fill:url(#XMLID_8977_);}
	.st619{fill:url(#XMLID_8980_);}
	.st620{fill:url(#XMLID_8981_);}
	.st621{fill:url(#XMLID_8984_);}
	.st622{fill:url(#XMLID_8985_);}
	.st623{fill:url(#XMLID_8986_);}
	.st624{fill:url(#XMLID_8987_);}
	.st625{fill:url(#XMLID_8988_);}
	.st626{fill:url(#XMLID_8991_);}
	.st627{fill:url(#XMLID_8992_);}
	.st628{fill:url(#XMLID_8995_);}
	.st629{fill:url(#XMLID_8996_);}
	.st630{fill:url(#XMLID_8997_);}
	.st631{fill:url(#XMLID_8998_);}
	.st632{fill:url(#XMLID_8999_);}
	.st633{opacity:0.4;fill:#1D1D1B;}
	.st634{fill:url(#XMLID_9181_);stroke:#383838;stroke-miterlimit:10;}
	.st635{fill:#282828;}
	.st636{fill:none;stroke:url(#XMLID_8234_);stroke-width:6;stroke-miterlimit:10;}
	.st637{fill:none;stroke:url(#XMLID_8520_);stroke-width:3;stroke-miterlimit:10;}
	.st638{fill:#28F7D1;}
	.st639{fill:none;stroke:url(#XMLID_8938_);stroke-width:3;stroke-miterlimit:10;}
	.st640{fill:url(#XMLID_9185_);stroke:#383838;stroke-miterlimit:10;}
	.st641{fill:#F7B033;}
	.st642{fill:#F7F7F7;}
	.st643{fill:#F7F8F9;}
	.st644{fill:url(#XMLID_9186_);stroke:#383838;stroke-miterlimit:10;}
	.st645{fill:none;stroke:url(#XMLID_8238_);stroke-width:6;stroke-miterlimit:10;}
	.st646{fill:none;stroke:url(#XMLID_9145_);stroke-width:3;stroke-miterlimit:10;}
	.st647{fill:#FFFFFF;stroke:url(#XMLID_8982_);stroke-width:3;stroke-miterlimit:10;}
	.st648{fill:none;stroke:url(#XMLID_9060_);stroke-width:6;stroke-miterlimit:10;}
	.st649{fill:#5E5E5E;}
	.st650{fill:#FFFFFF;stroke:url(#XMLID_9190_);stroke-width:3;stroke-miterlimit:10;}
	.st651{fill:#F9385D;}
	.st652{fill:#FFFFFF;stroke:url(#XMLID_9194_);stroke-width:3;stroke-miterlimit:10;}
	.st653{fill:url(#XMLID_8772_);stroke:#383838;stroke-miterlimit:10;}
	.st654{opacity:0.35;fill:#9FEDFF;}
	.st655{fill:url(#XMLID_8720_);stroke:#444444;stroke-miterlimit:10;}
	.st656{fill:url(#XMLID_8773_);stroke:#383838;stroke-miterlimit:10;}
	.st657{fill:url(#XMLID_8721_);stroke:#444444;stroke-miterlimit:10;}
	.st658{fill:#C07E61;}
	.st659{fill:#918E91;}
	.st660{fill:#FFFFFF;stroke:url(#XMLID_9199_);stroke-width:3;stroke-miterlimit:10;}
	.st661{fill:#C0C1BB;}
	.st662{fill:url(#XMLID_8725_);stroke:#444444;stroke-miterlimit:10;}
	.st663{fill:url(#XMLID_8726_);stroke:#444444;stroke-miterlimit:10;}
	.st664{fill:#C12F52;}
	.st665{fill:url(#XMLID_8727_);stroke:#444444;stroke-miterlimit:10;}
	.st666{fill:#929292;}
	.st667{fill:#C1A880;}
	.st668{fill:url(#XMLID_8728_);stroke:#444444;stroke-miterlimit:10;}
	.st669{fill:#C1C1C1;}
	.st670{fill:none;stroke:url(#XMLID_8540_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st671{fill:url(#XMLID_8729_);stroke:#444444;stroke-miterlimit:10;}
	.st672{fill:url(#SVGID_1_);}
	.st673{fill:#93837A;}
	.st674{fill:#9397A5;}
	.st675{fill:#939FA3;}
	.st676{fill:#93ADAD;}
	.st677{fill:none;stroke:url(#XMLID_8496_);stroke-width:3;stroke-miterlimit:10;}
	.st678{fill:url(#XMLID_8837_);stroke:#232323;stroke-miterlimit:10;}
	.st679{fill:#943B8A;}
	.st680{fill:#C3CDDD;}
	.st681{fill:none;stroke:url(#XMLID_8242_);stroke-width:6;stroke-miterlimit:10;}
	.st682{fill:#C7EE95;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}
	.st683{fill:url(#XMLID_8989_);stroke:#383838;stroke-miterlimit:10;}
	.st684{fill:#95BAC6;}
	.st685{fill:none;stroke:url(#XMLID_9032_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st686{fill:#C54EB9;}
	.st687{fill:#2B2B2B;}
	.st688{font-family:'FontBase-Regular';}
	.st689{fill:#FFFFFF;stroke:url(#XMLID_8884_);stroke-width:5;stroke-miterlimit:10;}
	.st690{fill:#FFFFFF;stroke:url(#XMLID_9035_);stroke-width:3;stroke-miterlimit:10;}
	.st691{fill:#FFFFFF;stroke:#B7B7B7;stroke-width:0.75;stroke-miterlimit:10;}
	.st692{fill:none;stroke:url(#XMLID_8825_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st693{fill:#C7EE95;}
	.st694{fill:#FFFFFF;stroke:url(#XMLID_9036_);stroke-width:3;stroke-miterlimit:10;}
	.st695{fill:#C7F2E9;}
	.st696{fill:none;stroke:url(#XMLID_8455_);stroke-width:6;stroke-miterlimit:10;}
	.st697{fill:#2D2D2D;}
	.st698{fill:#FBE429;}
	.st699{fill:none;stroke:url(#XMLID_9080_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st700{fill:none;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st701{fill:#998365;}
	.st702{fill:#99845F;}
	.st703{fill:url(#XMLID_8639_);stroke:#232323;stroke-miterlimit:10;}
	.st704{fill:none;stroke:#28F7D1;stroke-width:2;stroke-miterlimit:10;}
	.st705{fill:url(#XMLID_8737_);stroke:#444444;stroke-miterlimit:10;}
	.st706{fill:#C9C9C9;}
	.st707{fill:url(#XMLID_8738_);stroke:#444444;stroke-miterlimit:10;}
	.st708{fill:url(#XMLID_8739_);stroke:#444444;stroke-miterlimit:10;}
	.st709{fill:#605147;}
	.st710{fill:#605C60;}
	.st711{fill:#FFFFFF;stroke:url(#XMLID_8680_);stroke-width:0.25;stroke-miterlimit:10;}
	.st712{fill:none;stroke:url(#XMLID_9115_);stroke-width:6;stroke-miterlimit:10;}
	.st713{fill:none;stroke:url(#XMLID_9117_);stroke-width:6;stroke-miterlimit:10;}
	.st714{fill:url(#XMLID_8993_);stroke:#383838;stroke-miterlimit:10;}
	.st715{fill:#FF3BCC;}
	.st716{fill:#FF7676;}
	.st717{fill:url(#XMLID_8994_);stroke:#383838;stroke-miterlimit:10;}
	.st718{fill:#FF88A4;}
	.st719{fill:#FF9852;}
	.st720{fill:#FFAF50;}
	.st721{fill:#FFB236;}
	.st722{fill:#FFBC73;}
	.st723{fill:#FFC555;}
	.st724{fill:#FFD366;}
	.st725{fill:#FFD773;}
	.st726{fill:#FFD77E;}
	.st727{fill:#FFDB92;}
	.st728{fill:#FFE2CA;}
	.st729{fill:#FFE52C;}
	.st730{fill:#FFE825;}
	.st731{fill:#FFEFAB;}
	.st732{fill:#FFFF00;}
	.st733{fill:#FFFFFF;}
	.st734{opacity:0.27;fill:#605C60;}
	.st735{fill:none;stroke:url(#XMLID_9163_);stroke-width:3;stroke-miterlimit:10;}
	.st736{fill:none;stroke:url(#XMLID_8543_);stroke-width:3;stroke-miterlimit:10;}
	.st737{fill:#FFFFFF;stroke:url(#XMLID_8702_);stroke-width:0.25;stroke-miterlimit:10;}
	.st738{fill:#FFFFFF;stroke:url(#XMLID_8684_);stroke-width:0.25;stroke-miterlimit:10;}
	.st739{fill:none;}
	.st740{fill:none;stroke:url(#XMLID_9083_);stroke-width:6;stroke-miterlimit:10;}
	.st741{fill:#FFFFFF;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st742{fill:url(#XMLID_8740_);stroke:#444444;stroke-miterlimit:10;}
	.st743{fill:#FFFFFF;stroke:url(#XMLID_8712_);stroke-width:0.25;stroke-miterlimit:10;}
	.st744{fill:#666461;}
	.st745{fill:#666666;}
	.st746{fill:#FFFFFF;stroke:url(#XMLID_8694_);stroke-width:0.25;stroke-miterlimit:10;}
	.st747{fill:none;stroke:url(#XMLID_9203_);stroke-width:3;stroke-miterlimit:10;}
	.st748{fill:url(#XMLID_8741_);stroke:#444444;stroke-miterlimit:10;}
	.st749{fill:#9A5F3E;}
	.st750{fill:#9AF2F7;}
	.st751{fill:url(#XMLID_8745_);stroke:#444444;stroke-miterlimit:10;}
	.st752{fill:#FFFFFF;stroke:url(#XMLID_8706_);stroke-width:0.25;stroke-miterlimit:10;}
	.st753{fill:#9B9B9B;}
	.st754{fill:#FFFFFF;stroke:url(#XMLID_8688_);stroke-width:0.25;stroke-miterlimit:10;}
	.st755{fill:url(#XMLID_8746_);stroke:#444444;stroke-miterlimit:10;}
	.st756{fill:#CACCC8;}
	.st757{fill:url(#XMLID_8747_);stroke:#444444;stroke-miterlimit:10;}
	.st758{fill:#9BC16B;}
	.st759{fill:url(#XMLID_9000_);}
	.st760{fill:url(#XMLID_9001_);}
	.st761{fill:url(#XMLID_9004_);}
	.st762{fill:url(#XMLID_9006_);}
	.st763{fill:url(#XMLID_9007_);}
	.st764{fill:url(#XMLID_9008_);}
	.st765{fill:url(#XMLID_9010_);}
	.st766{fill:url(#XMLID_9011_);}
	.st767{fill:url(#XMLID_9013_);}
	.st768{fill:url(#XMLID_9014_);}
	.st769{fill:url(#XMLID_9015_);}
	.st770{fill:url(#XMLID_9016_);}
	.st771{fill:url(#XMLID_9017_);}
	.st772{fill:url(#XMLID_9018_);}
	.st773{fill:url(#XMLID_9019_);}
	.st774{fill:url(#XMLID_9020_);}
	.st775{fill:url(#XMLID_9021_);}
	.st776{fill:url(#XMLID_9022_);}
	.st777{fill:url(#XMLID_9023_);}
	.st778{fill:url(#XMLID_9024_);}
	.st779{fill:url(#XMLID_9025_);}
	.st780{fill:url(#XMLID_9026_);}
	.st781{fill:url(#XMLID_9027_);}
	.st782{fill:url(#XMLID_9028_);}
	.st783{fill:url(#XMLID_9029_);}
	.st784{fill:url(#XMLID_9030_);}
	.st785{fill:url(#XMLID_9031_);}
	.st786{fill:url(#XMLID_9038_);}
	.st787{fill:url(#XMLID_9039_);}
	.st788{fill:url(#XMLID_9040_);}
	.st789{fill:url(#XMLID_9041_);}
	.st790{fill:url(#XMLID_9044_);}
	.st791{fill:url(#XMLID_9045_);}
	.st792{fill:url(#XMLID_9046_);}
	.st793{fill:url(#XMLID_9047_);}
	.st794{fill:url(#XMLID_9050_);}
	.st795{fill:url(#XMLID_9051_);}
	.st796{fill:url(#XMLID_9053_);}
	.st797{fill:url(#XMLID_9055_);}
	.st798{fill:url(#XMLID_9056_);}
	.st799{fill:url(#XMLID_9057_);}
	.st800{fill:url(#XMLID_9058_);}
	.st801{fill:url(#XMLID_9059_);}
	.st802{fill:url(#XMLID_8748_);stroke:#444444;stroke-miterlimit:10;}
	.st803{fill:url(#XMLID_9061_);}
	.st804{fill:url(#XMLID_9062_);}
	.st805{fill:url(#XMLID_9063_);}
	.st806{fill:url(#XMLID_9064_);}
	.st807{fill:url(#XMLID_9065_);}
	.st808{fill:url(#XMLID_9066_);}
	.st809{fill:url(#XMLID_9067_);}
	.st810{fill:url(#XMLID_9068_);}
	.st811{fill:url(#XMLID_9069_);}
	.st812{fill:url(#XMLID_9070_);}
	.st813{fill:url(#XMLID_9071_);}
	.st814{fill:url(#XMLID_9072_);}
	.st815{fill:url(#XMLID_9073_);}
	.st816{fill:url(#XMLID_9074_);}
	.st817{fill:url(#XMLID_9075_);}
	.st818{fill:url(#XMLID_9076_);}
	.st819{fill:url(#XMLID_9077_);}
	.st820{fill:url(#XMLID_9078_);}
	.st821{fill:url(#XMLID_9079_);}
	.st822{fill:url(#XMLID_9084_);}
	.st823{fill:url(#XMLID_9085_);}
	.st824{fill:url(#XMLID_9086_);}
	.st825{fill:url(#XMLID_9087_);}
	.st826{fill:url(#XMLID_9088_);}
	.st827{fill:url(#XMLID_9089_);}
	.st828{fill:url(#XMLID_9090_);}
	.st829{fill:url(#XMLID_9091_);}
	.st830{fill:url(#XMLID_9092_);}
	.st831{fill:url(#XMLID_9093_);}
	.st832{fill:url(#XMLID_9094_);}
	.st833{fill:url(#XMLID_9095_);}
	.st834{fill:url(#XMLID_9096_);}
	.st835{fill:url(#XMLID_9097_);}
	.st836{fill:url(#XMLID_9098_);}
	.st837{fill:url(#XMLID_9099_);}
	.st838{fill:#686868;}
	.st839{fill:#68696D;}
	.st840{fill:none;stroke:url(#XMLID_8759_);stroke-width:3;stroke-miterlimit:10;}
	.st841{fill:url(#XMLID_8749_);stroke:#444444;stroke-miterlimit:10;}
	.st842{fill:#9CA09D;}
	.st843{fill:none;stroke:url(#XMLID_8788_);stroke-width:4;stroke-miterlimit:10;}
	.st844{fill:url(#XMLID_9100_);}
	.st845{fill:url(#XMLID_9101_);}
	.st846{fill:url(#XMLID_9102_);}
	.st847{fill:url(#XMLID_9103_);}
	.st848{fill:url(#XMLID_9104_);}
	.st849{fill:url(#XMLID_9105_);}
	.st850{fill:url(#XMLID_9106_);}
	.st851{fill:url(#XMLID_9107_);}
	.st852{fill:url(#XMLID_9108_);}
	.st853{fill:url(#XMLID_9109_);}
	.st854{fill:url(#XMLID_9110_);}
	.st855{fill:url(#XMLID_9111_);}
	.st856{fill:url(#XMLID_9112_);}
	.st857{fill:url(#XMLID_9113_);}
	.st858{fill:url(#XMLID_9114_);}
	.st859{fill:url(#XMLID_9116_);}
	.st860{fill:url(#XMLID_9118_);}
	.st861{fill:url(#XMLID_9119_);}
	.st862{fill:url(#XMLID_9120_);}
	.st863{fill:url(#XMLID_9123_);}
	.st864{fill:url(#XMLID_9126_);}
	.st865{fill:url(#XMLID_9127_);}
	.st866{fill:url(#XMLID_9128_);}
	.st867{fill:url(#XMLID_9130_);}
	.st868{fill:url(#XMLID_9133_);}
	.st869{fill:url(#XMLID_9134_);}
	.st870{fill:url(#XMLID_9135_);}
	.st871{fill:url(#XMLID_9136_);}
	.st872{fill:url(#XMLID_9137_);}
	.st873{fill:url(#XMLID_9140_);}
	.st874{fill:url(#XMLID_9141_);}
	.st875{fill:url(#XMLID_9144_);}
	.st876{fill:url(#XMLID_9147_);}
	.st877{fill:url(#XMLID_9148_);}
	.st878{fill:url(#XMLID_9149_);}
	.st879{fill:url(#XMLID_9150_);}
	.st880{fill:url(#XMLID_9152_);}
	.st881{fill:url(#XMLID_9153_);}
	.st882{fill:url(#XMLID_9154_);}
	.st883{fill:url(#XMLID_9155_);}
	.st884{fill:url(#XMLID_9156_);}
	.st885{fill:url(#XMLID_9157_);}
	.st886{fill:url(#XMLID_9158_);}
	.st887{fill:url(#XMLID_9161_);}
	.st888{fill:url(#XMLID_9162_);}
	.st889{fill:url(#XMLID_9165_);}
	.st890{fill:url(#XMLID_9166_);}
	.st891{fill:url(#XMLID_9167_);}
	.st892{fill:url(#XMLID_9168_);}
	.st893{fill:url(#XMLID_9169_);}
	.st894{fill:none;stroke:url(#XMLID_8789_);stroke-width:4;stroke-miterlimit:10;}
	.st895{fill:url(#XMLID_9170_);}
	.st896{fill:url(#XMLID_9171_);}
	.st897{fill:url(#XMLID_9172_);}
	.st898{fill:url(#XMLID_9173_);}
	.st899{fill:url(#XMLID_9176_);}
	.st900{fill:url(#XMLID_9177_);}
	.st901{fill:url(#XMLID_9178_);}
	.st902{fill:url(#XMLID_9179_);}
	.st903{fill:url(#XMLID_9180_);}
	.st904{fill:url(#XMLID_9183_);}
	.st905{fill:url(#XMLID_9184_);}
	.st906{fill:url(#XMLID_9187_);}
	.st907{fill:url(#XMLID_9189_);}
	.st908{fill:url(#XMLID_9191_);}
	.st909{fill:url(#XMLID_9193_);}
	.st910{fill:url(#XMLID_9195_);}
	.st911{fill:url(#XMLID_9196_);}
	.st912{fill:url(#XMLID_9197_);}
	.st913{fill:url(#XMLID_9198_);}
	.st914{fill:#CCA885;}
	.st915{fill:#CCCCCC;}
	.st916{fill:#CCD8E2;}
	.st917{fill:url(#XMLID_9201_);}
	.st918{fill:url(#XMLID_9202_);}
	.st919{fill:url(#XMLID_9204_);}
	.st920{fill:url(#XMLID_9206_);}
	.st921{fill:url(#XMLID_9207_);}
	.st922{fill:url(#XMLID_9209_);}
	.st923{fill:url(#XMLID_9210_);}
	.st924{fill:url(#XMLID_9211_);}
	.st925{fill:url(#XMLID_8836_);stroke:#383838;stroke-miterlimit:10;}
	.st926{fill:url(#XMLID_9212_);}
	.st927{fill:url(#XMLID_9213_);}
	.st928{fill:url(#XMLID_9215_);}
	.st929{clip-path:url(#XMLID_8239_);}
	.st930{fill:url(#XMLID_9216_);}
	.st931{fill:url(#XMLID_9217_);}
	.st932{fill:url(#XMLID_9218_);}
	.st933{fill:url(#XMLID_9219_);}
	.st934{fill:url(#XMLID_9220_);}
	.st935{fill:url(#XMLID_9221_);}
	.st936{fill:url(#XMLID_9222_);}
	.st937{fill:url(#XMLID_9224_);}
	.st938{fill:url(#XMLID_9225_);}
	.st939{fill:#9E7F66;}
	.st940{clip-path:url(#XMLID_8305_);}
	.st941{clip-path:url(#XMLID_8307_);}
	.st942{fill:#303233;}
	.st943{fill:#303844;}
	.st944{clip-path:url(#XMLID_8315_);}
	.st945{fill:none;stroke:url(#XMLID_9002_);stroke-width:3;stroke-miterlimit:10;}
	.st946{fill:#CECECE;}
	.st947{clip-path:url(#XMLID_8403_);}
	.st948{clip-path:url(#XMLID_8418_);}
	.st949{clip-path:url(#XMLID_8421_);}
	.st950{fill:#9FF4F4;}
	.st951{clip-path:url(#XMLID_8468_);}
	.st952{fill:none;stroke:url(#XMLID_8829_);stroke-width:4;stroke-miterlimit:10;}
	.st953{clip-path:url(#XMLID_8500_);}
	.st954{fill:none;stroke:url(#XMLID_8115_);stroke-width:2;stroke-miterlimit:10;}
	.st955{fill:#32ADF0;}
	.st956{fill:none;stroke:url(#XMLID_8731_);stroke-width:2;stroke-miterlimit:10;}
	.st957{fill:#333333;}
	.st958{fill:none;stroke:url(#XMLID_8732_);stroke-width:2;stroke-miterlimit:10;}
	.st959{clip-path:url(#XMLID_8655_);}
	.st960{clip-path:url(#XMLID_8659_);}
	.st961{clip-path:url(#XMLID_8661_);}
	.st962{opacity:0.24;fill:#FFFFFF;}
	.st963{fill:none;stroke:url(#XMLID_8306_);stroke-width:6;stroke-miterlimit:10;}
	.st964{fill:none;stroke:url(#XMLID_8733_);stroke-width:2;stroke-miterlimit:10;}
	.st965{fill:#FFFFFF;stroke:#CCCCCC;stroke-miterlimit:10;}
	.st966{fill:none;stroke:url(#XMLID_8760_);stroke-width:3;stroke-miterlimit:10;}
	.st967{fill:none;stroke:url(#XMLID_8734_);stroke-width:2;stroke-miterlimit:10;}
	.st968{fill:none;stroke:url(#XMLID_8761_);stroke-width:3;stroke-miterlimit:10;}
	.st969{clip-path:url(#XMLID_8751_);}
	.st970{clip-path:url(#XMLID_8784_);}
	.st971{fill:url(#XMLID_8754_);stroke:#444444;stroke-miterlimit:10;}
	.st972{fill:url(#XMLID_8638_);stroke:#383838;stroke-miterlimit:10;}
	.st973{opacity:0.5;fill:#A1A1A1;}
	.st974{fill:url(#XMLID_8755_);stroke:#444444;stroke-miterlimit:10;}
	.st975{fill:#352B1B;}
	.st976{clip-path:url(#XMLID_8800_);}
	.st977{fill:none;stroke:#444444;stroke-miterlimit:10;}
	.st978{fill:#353535;}
	.st979{fill:#353638;}
	.st980{clip-path:url(#XMLID_8830_);}
	.st981{fill:#3574DC;}
	.st982{clip-path:url(#XMLID_8895_);}
	.st983{fill:url(#XMLID_8840_);stroke:#383838;stroke-miterlimit:10;}
	.st984{clip-path:url(#XMLID_8901_);}
	.st985{clip-path:url(#XMLID_8919_);}
	.st986{fill:url(#XMLID_8841_);stroke:#383838;stroke-miterlimit:10;}
	.st987{clip-path:url(#XMLID_8973_);}
	.st988{clip-path:url(#XMLID_8983_);}
	.st989{fill:none;stroke:url(#XMLID_8969_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st990{fill:none;stroke:url(#XMLID_8803_);stroke-width:3;stroke-miterlimit:10;}
	.st991{fill:#6B7284;}
	.st992{fill:none;stroke:url(#XMLID_8804_);stroke-width:3;stroke-miterlimit:10;}
	.st993{fill:none;stroke:url(#XMLID_8978_);stroke-width:3;stroke-miterlimit:10;}
	.st994{fill:#39466B;}
	.st995{fill:#397AC9;}
	.st996{fill:#6D6D6D;}
	.st997{fill:none;stroke:url(#XMLID_9188_);stroke-width:3;stroke-miterlimit:10;}
	.st998{fill:#001F77;}
	.st999{fill:#003449;}
	.st1000{fill:#004263;}
	.st1001{fill:#006384;}
	.st1002{fill:#006937;}
	.st1003{fill:#008FB6;}
	.st1004{fill:#00B2CD;}
	.st1005{fill:url(#XMLID_8642_);stroke:#383838;stroke-miterlimit:10;}
	.st1006{fill:none;stroke:url(#XMLID_8156_);stroke-width:3;stroke-miterlimit:10;}
	.st1007{fill:url(#XMLID_8643_);stroke:#383838;stroke-miterlimit:10;}
	.st1008{fill:none;stroke:url(#XMLID_8319_);stroke-width:6;stroke-miterlimit:10;}
	.st1009{fill:#020202;}
	.st1010{fill:#D0D0D0;}
	.st1011{fill:none;stroke:#2368D9;stroke-width:3;stroke-miterlimit:10;}
	.st1012{opacity:0.3;fill:#1D1D1B;}
	.st1013{fill:#D1D1D1;}
	.st1014{fill:#D29472;}
	.st1015{fill:#042AB2;}
	.st1016{opacity:0.19;fill:#998365;}
	.st1017{fill:none;stroke:#E50A0A;stroke-width:2;stroke-miterlimit:10;}
	.st1018{fill:none;stroke:url(#XMLID_9192_);stroke-width:3;stroke-miterlimit:10;}
	.st1019{fill:#3A2914;}
	.st1020{fill:#3A3A3A;}
	.st1021{fill:none;stroke:url(#XMLID_8118_);stroke-width:6;stroke-miterlimit:10;}
	.st1022{fill:#3A4747;}
	.st1023{fill:#D6D6D6;}
	.st1024{fill:url(#XMLID_424_);}
	.st1025{fill:url(#XMLID_426_);}
	.st1026{fill:url(#XMLID_427_);}
	.st1027{fill:url(#XMLID_430_);}
	.st1028{fill:url(#XMLID_432_);}
	.st1029{fill:url(#XMLID_450_);}
	.st1030{fill:#FFFFFF;stroke:url(#XMLID_8701_);stroke-width:0.25;stroke-miterlimit:10;}
	.st1031{fill:#FFFFFF;stroke:url(#XMLID_8683_);stroke-width:0.25;stroke-miterlimit:10;}
	.st1032{fill:url(#XMLID_8507_);stroke:#232323;stroke-miterlimit:10;}
	.st1033{fill:#3D3D3D;}
	.st1034{fill:none;stroke:url(#XMLID_8970_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1035{fill:none;stroke:url(#XMLID_9121_);stroke-width:5;stroke-miterlimit:10;}
	.st1036{fill:#FFFFFF;stroke:url(#XMLID_8711_);stroke-width:0.25;stroke-miterlimit:10;}
	.st1037{fill:#FFFFFF;stroke:url(#XMLID_8693_);stroke-width:0.25;stroke-miterlimit:10;}
	.st1038{fill:#707070;}
	.st1039{fill:none;stroke:url(#XMLID_8541_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1040{fill:#FFFFFF;stroke:url(#XMLID_8705_);stroke-width:0.25;stroke-miterlimit:10;}
	.st1041{fill:#FFFFFF;stroke:url(#XMLID_8687_);stroke-width:0.25;stroke-miterlimit:10;}
	.st1042{fill:#A0A0A0;}
	.st1043{fill:none;stroke:url(#XMLID_8122_);stroke-width:6;stroke-miterlimit:10;}
	.st1044{fill:#727272;}
	.st1045{fill:none;stroke:url(#XMLID_8853_);stroke-width:4;stroke-miterlimit:10;}
	.st1046{fill:none;stroke:url(#XMLID_8827_);stroke-width:3;stroke-miterlimit:10;}
	.st1047{fill:#A2A599;}
	.st1048{fill:#A2A7AC;}
	.st1049{fill:none;stroke:url(#XMLID_9033_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1050{fill:url(#XMLID_8926_);stroke:#232323;stroke-miterlimit:10;}
	.st1051{fill:#A3A3A3;}
	.st1052{fill:none;stroke:#28F7D1;stroke-miterlimit:10;}
	.st1053{fill:#A4704C;}
	.st1054{fill:#A4BCC1;}
	.st1055{fill:#0A2D56;}
	.st1056{fill:#A57B44;}
	.st1057{fill:none;stroke:url(#SVGID_2_);stroke-width:5;stroke-miterlimit:10;}
	.st1058{fill:url(#XMLID_9139_);stroke:#232323;stroke-miterlimit:10;}
	.st1059{fill:none;stroke:url(#XMLID_8826_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1060{fill:none;stroke:url(#XMLID_9081_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1061{fill:#FFFFFF;stroke:url(#XMLID_8915_);stroke-width:3;stroke-miterlimit:10;}
	.st1062{fill:#777777;}
	.st1063{fill:#DA9571;}
	.st1064{fill:#0C455B;}
	.st1065{fill:#FFFFFF;stroke:url(#XMLID_9122_);stroke-width:3;stroke-miterlimit:10;}
	.st1066{fill:#FFFFFF;stroke:url(#XMLID_8918_);stroke-width:3;stroke-miterlimit:10;}
	.st1067{clip-path:url(#XMLID_9037_);}
	.st1068{clip-path:url(#XMLID_9043_);}
	.st1069{fill:#DB6812;}
	.st1070{fill:none;stroke:url(#XMLID_8799_);stroke-width:3;stroke-miterlimit:10;}
	.st1071{fill:#0D1F30;}
	.st1072{fill:#FFFFFF;stroke:url(#XMLID_9125_);stroke-width:3;stroke-miterlimit:10;}
	.st1073{clip-path:url(#XMLID_9132_);}
	.st1074{clip-path:url(#XMLID_9160_);}
	.st1075{fill:#A8947E;}
	.st1076{clip-path:url(#XMLID_9175_);}
	.st1077{fill:none;stroke:url(#XMLID_8546_);stroke-width:6;stroke-miterlimit:10;}
	.st1078{fill:#A8A8A8;}
	.st1079{fill:#FFFFFF;stroke:url(#XMLID_9129_);stroke-width:3;stroke-miterlimit:10;}
	.st1080{fill:#79E0E0;}
	.st1081{fill:#DCFFF8;}
	.st1082{clip-path:url(#XMLID_9200_);}
	.st1083{fill:url(#XMLID_8483_);stroke:#232323;stroke-miterlimit:10;}
	.st1084{fill:#0F0F0F;}
	.st1085{fill:none;stroke:url(#XMLID_8863_);stroke-width:4;stroke-miterlimit:10;}
	.st1086{fill:#0F4B63;}
	.st1087{fill:#DDDDDD;}
	.st1088{fill:#DDE5ED;}
	.st1089{fill:#404949;}
	.st1090{fill:none;stroke:url(#XMLID_9042_);stroke-width:3;stroke-miterlimit:10;}
	.st1091{fill:none;stroke:url(#XMLID_8137_);stroke-width:6;stroke-miterlimit:10;}
	.st1092{fill:#DEFFAE;}
	.st1093{fill:#DFDFDF;}
	.st1094{font-size:20.0331;}
	.st1095{fill:#424242;}
	.st1096{fill:none;stroke:url(#XMLID_8347_);stroke-width:6;stroke-miterlimit:10;}
	.st1097{opacity:0.51;fill:#FFFFFF;enable-background:new    ;}
	.st1098{fill:url(#XMLID_8506_);stroke:#383838;stroke-miterlimit:10;}
	.st1099{fill:#444444;}
	.st1100{fill:#FFFFFF;stroke:url(#XMLID_9131_);stroke-width:3;stroke-miterlimit:10;}
    .oculto{
      display: none;
    }
    #img1,#img2,#img3,#img4,#img5,#img6,#img7,#img8{
       cursor: pointer;
    }
</style>